'use strict';

/* ============================================================
   Soccer Revolution — Quiniela Mundial 2026
   Sistema completo de predicciones para la fase de knockouts
   Backend: Firebase Authentication + Cloud Firestore
   ============================================================ */

// ── DATOS DEL MUNDIAL 2026 ─────────────────────────────────

const MUNDIAL_DATA = {

  fases: [
    { id: 'dieciseisavos', nombre: '16VOS DE FINAL', icono: '⚽',
      fechas: '28 Jun — 3 Jul 2026',
      puntos: { resultado: 2, exacto: 5, anotador: 2 }, activa: true },
    { id: 'octavos', nombre: '8VOS DE FINAL',  icono: '⚡',
      fechas: '4 Jul — 7 Jul 2026',
      puntos: { resultado: 4, exacto: 8, anotador: 3 }, activa: false },
    { id: 'cuartos', nombre: 'CUARTOS',         icono: '🔥',
      fechas: '9 Jul — 11 Jul 2026',
      puntos: { resultado: 6, exacto: 12, anotador: 4 }, activa: false },
    { id: 'semifinal', nombre: 'SEMIFINALES',    icono: '💥',
      fechas: '14 Jul — 15 Jul 2026',
      puntos: { resultado: 10, exacto: 20, anotador: 6 }, activa: false },
    { id: 'tercer_lugar', nombre: 'TERCER LUGAR', icono: '🥉',
      fechas: '18 Jul 2026',
      puntos: { resultado: 10, exacto: 20, anotador: 6 }, activa: false },
    { id: 'final', nombre: 'GRAN FINAL',         icono: '🏆',
      fechas: '19 Jul 2026',
      puntos: { resultado: 20, exacto: 50, anotador: 10 }, activa: false }
  ],

  partidos: {
    dieciseisavos: [
      { id: 'M01', num: 73, fecha: '28 Jun 2026', hora: 'Por confirmar',
        sede: 'SoFi Stadium, Los Ángeles',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M02', num: 74, fecha: '29 Jun 2026', hora: 'Por confirmar',
        sede: 'NRG Stadium, Houston',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M03', num: 75, fecha: '29 Jun 2026', hora: 'Por confirmar',
        sede: 'Gillette Stadium, Boston/Foxborough',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M04', num: 76, fecha: '29 Jun 2026', hora: 'Por confirmar',
        sede: 'Estadio BBVA, Monterrey',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M05', num: 77, fecha: '30 Jun 2026', hora: 'Por confirmar',
        sede: 'AT&T Stadium, Dallas/Arlington',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M06', num: 78, fecha: '30 Jun 2026', hora: 'Por confirmar',
        sede: 'MetLife Stadium, East Rutherford',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M07', num: 79, fecha: '30 Jun 2026', hora: 'Por confirmar',
        sede: 'Estadio Azteca, Ciudad de México',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M08', num: 80, fecha: '1 Jul 2026', hora: 'Por confirmar',
        sede: 'Mercedes-Benz Stadium, Atlanta',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M09', num: 81, fecha: '1 Jul 2026', hora: 'Por confirmar',
        sede: 'Lumen Field, Seattle',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M10', num: 82, fecha: '1 Jul 2026', hora: 'Por confirmar',
        sede: "Levi's Stadium, Santa Clara",
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M11', num: 83, fecha: '2 Jul 2026', hora: 'Por confirmar',
        sede: 'SoFi Stadium, Los Ángeles',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M12', num: 84, fecha: '2 Jul 2026', hora: 'Por confirmar',
        sede: 'BMO Field, Toronto',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M13', num: 85, fecha: '2 Jul 2026', hora: 'Por confirmar',
        sede: 'BC Place, Vancouver',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M14', num: 86, fecha: '3 Jul 2026', hora: 'Por confirmar',
        sede: 'AT&T Stadium, Dallas/Arlington',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M15', num: 87, fecha: '3 Jul 2026', hora: 'Por confirmar',
        sede: 'Hard Rock Stadium, Miami',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' },
      { id: 'M16', num: 88, fecha: '3 Jul 2026', hora: 'Por confirmar',
        sede: 'Arrowhead Stadium, Kansas City',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'pendiente' }
    ],

    octavos: [
      { id: 'M17', num: 89, fecha: '4 Jul 2026', hora: 'Por confirmar',
        sede: 'NRG Stadium, Houston',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' },
      { id: 'M18', num: 90, fecha: '4 Jul 2026', hora: 'Por confirmar',
        sede: 'Lincoln Financial Field, Philadelphia',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' },
      { id: 'M19', num: 91, fecha: '5 Jul 2026', hora: 'Por confirmar',
        sede: 'MetLife Stadium, East Rutherford',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' },
      { id: 'M20', num: 92, fecha: '5 Jul 2026', hora: 'Por confirmar',
        sede: 'Estadio Azteca, Ciudad de México',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' },
      { id: 'M21', num: 93, fecha: '6 Jul 2026', hora: 'Por confirmar',
        sede: 'AT&T Stadium, Arlington/Dallas',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' },
      { id: 'M22', num: 94, fecha: '6 Jul 2026', hora: 'Por confirmar',
        sede: 'Lumen Field, Seattle',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' },
      { id: 'M23', num: 95, fecha: '7 Jul 2026', hora: 'Por confirmar',
        sede: 'Mercedes-Benz Stadium, Atlanta',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' },
      { id: 'M24', num: 96, fecha: '7 Jul 2026', hora: 'Por confirmar',
        sede: 'BC Place, Vancouver',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' }
    ],

    cuartos: [
      { id: 'M25', num: 97, fecha: '9 Jul 2026', hora: 'Por confirmar',
        sede: 'Gillette Stadium, Boston/Foxborough',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' },
      { id: 'M26', num: 98, fecha: '10 Jul 2026', hora: 'Por confirmar',
        sede: 'SoFi Stadium, Los Ángeles',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' },
      { id: 'M27', num: 99, fecha: '11 Jul 2026', hora: 'Por confirmar',
        sede: 'Hard Rock Stadium, Miami',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' },
      { id: 'M28', num: 100, fecha: '11 Jul 2026', hora: 'Por confirmar',
        sede: 'Arrowhead Stadium, Kansas City',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' }
    ],

    semifinal: [
      { id: 'M29', num: 101, fecha: '14 Jul 2026', hora: 'Por confirmar',
        sede: 'AT&T Stadium, Arlington/Dallas',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' },
      { id: 'M30', num: 102, fecha: '15 Jul 2026', hora: 'Por confirmar',
        sede: 'Mercedes-Benz Stadium, Atlanta',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' }
    ],

    tercer_lugar: [
      { id: 'M31', num: 103, fecha: '18 Jul 2026', hora: 'Por confirmar',
        sede: 'Hard Rock Stadium, Miami',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' }
    ],

    final: [
      { id: 'M32', num: 104, fecha: '19 Jul 2026', hora: 'Por confirmar',
        sede: 'MetLife Stadium, East Rutherford, Nueva Jersey',
        local: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        visitante: { nombre: 'Por definir', bandera: '🏳️', escudo: '', jugadores: [] },
        resultado: null, estado: 'bloqueado' }
    ]
  }
};

// ── SEGURIDAD: escape de HTML ───────────────────────────────
// Cualquier dato que venga de un campo de texto libre (nombre, selección
// favorita, nombres de equipo/jugador puestos por el admin, etc.) se inserta
// vía innerHTML en varias pantallas. Sin escapar, un registro con
// "<img src=x onerror=...>" en el nombre ejecutaría JS en el navegador de
// CUALQUIERA que vea el ranking — o, peor, en el panel admin.
function escapeHTML(str) {
  return String(str === undefined || str === null ? '' : str).replace(/[&<>"']/g, c => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ));
}

// Bonos de racha — objeto mutable a propósito: quiniela_config/points puede
// sobreescribir estos valores por defecto (ver QuinielaApp._applyPointsConfig).
// Mantenerlo como un objeto compartido (en vez de constantes sueltas) permite
// que TODAS las funciones que lo referencian (calculatePointsFor, renderMisStats,
// etc.) reciban automáticamente el valor personalizado sin tener que tocar cada
// sitio uno por uno.
const RACHA_BONUS = { streak3: 5, streak5: 15, streak8: 30 };

// En redes móviles lentas/inestables, una lectura a Firestore puede quedarse
// esperando sin nunca resolver ni rechazar — sin esto, el código quedaría
// colgado indefinidamente en ese `await`. Esto la fuerza a fallar rápido.
function withTimeout(promise, ms) {
  return Promise.race([
    promise,
    new Promise((_, reject) => setTimeout(() => reject({ code: 'timeout' }), ms))
  ]);
}

// ── APP PRINCIPAL ──────────────────────────────────────────

const QuinielaApp = {

  db: null,
  auth: null,

  currentUser: null,     // { uid, nombre, username, email, pais, seleccion, avatar, createdAt }
  myPredictions: {},      // predicciones del usuario actual (matchId -> {...})
  currentPhase: 'dieciseisavos',
  tempScores: {},
  totalUsers: 0,

  data: { matches: null, results: {}, adminConfig: { fasesActivas: ['dieciseisavos'], premios: null },
    sponsors: { title: null, banners: [] } },

  // ── INIT ────────────────────────────────────────────────

  async init() {
    this.db = firebase.firestore();
    this.auth = firebase.auth();
    this.startLockCountdowns();
    await this.loadPublicStats();
    this.updateHeroStats();
    this.startLandingCountdown();
    this.initSound();

    // Este listener solo maneja la carga INICIAL de la página (sesión ya
    // existente al recargar/volver) o un cierre de sesión externo.
    // register()/login() manejan su propio flujo de éxito directamente —
    // si dependiéramos de este listener para eso, se dispara apenas se crea
    // la cuenta en Auth, ANTES de que el perfil en Firestore exista todavía,
    // y pondría currentUser en null por error.
    this.auth.onAuthStateChanged(async fbUser => {
      if (fbUser) {
        if (this.currentUser && this.currentUser.uid === fbUser.uid) return; // ya manejado
        await this.loadCurrentUser(fbUser.uid);
        if (this.currentUser) {
          this.showScreen('dashboard'); // showScreen() ya recarga matches/results/admin
        } else {
          // Dos casos posibles aquí: (a) el perfil aún no se terminó de
          // escribir justo después de crear la cuenta — register() se
          // encarga de completar esa transición momentos después, o
          // (b) la lectura falló/tardó demasiado (sin conexión, red lenta).
          // En ambos casos mostramos landing en vez de dejar la pantalla
          // negra vacía indefinidamente; si es (a), register() la corrige
          // enseguida mostrando el dashboard.
          this.showScreen('landing');
        }
      } else {
        this.currentUser = null;
        this.showScreen('landing');
      }
    });
  },

  // ── PERSISTENCIA (Firestore) ────────────────────────────

  async loadPublicStats() {
    // Stats doc is publicly readable — keep isolated so a failure in other reads can't zero it out
    try {
      const snap = await withTimeout(this.db.collection('quiniela_config').doc('stats').get(), 6000);
      this.totalUsers = snap.exists ? (snap.data().totalUsers || 0) : 0;
    } catch (e) { this.totalUsers = 0; }

    // Admin + matches may require auth — separate try/catch so stats are never affected
    try {
      const [adminSnap, matchesSnap, pointsSnap] = await withTimeout(Promise.all([
        this.db.collection('quiniela_config').doc('admin').get(),
        this.db.collection('quiniela_config').doc('matches').get(),
        this.db.collection('quiniela_config').doc('points').get()
      ]), 6000);
      const fasesActivas = adminSnap.exists ? (adminSnap.data().fasesActivas || ['dieciseisavos']) : ['dieciseisavos'];
      const matchesData  = matchesSnap.exists ? matchesSnap.data() : {};
      const faseOrder = ['dieciseisavos','octavos','cuartos','semifinal','tercer_lugar','final'];
      let lastActiveIdx = 0;
      faseOrder.forEach((fid, idx) => { if (fasesActivas.includes(fid)) lastActiveIdx = idx; });
      this.landingData = { fasesActivas, lastActiveIdx, matchesData };
      this._applyPointsConfig(pointsSnap.exists ? pointsSnap.data() : null);
      this.renderPointsTable();
    } catch (e) {
      this.landingData = { fasesActivas: ['dieciseisavos'], lastActiveIdx: 0, matchesData: {} };
    }
  },

  // Combina quiniela_config/points con los valores por defecto de MUNDIAL_DATA
  // y RACHA_BONUS, MUTÁNDOLOS EN SITIO. Como MUNDIAL_DATA es un único objeto
  // compartido por todo el módulo, esto hace que cualquier función que lea
  // fase.puntos (calcMatchPoints, renderMisStats, etc.) reciba automáticamente
  // el valor personalizado del admin sin tener que tocar cada función una por una.
  _applyPointsConfig(points) {
    if (!points) return;
    MUNDIAL_DATA.fases.forEach(fase => {
      if (points[fase.id]) Object.assign(fase.puntos, points[fase.id]);
    });
    if (points.racha) Object.assign(RACHA_BONUS, points.racha);
  },

  async loadConfig() {
    try {
      const [matchesSnap, resultsSnap, adminSnap, pointsSnap, sponsorsSnap] = await withTimeout(Promise.all([
        this.db.collection('quiniela_config').doc('matches').get(),
        this.db.collection('quiniela_config').doc('results').get(),
        this.db.collection('quiniela_config').doc('admin').get(),
        this.db.collection('quiniela_config').doc('points').get(),
        this.db.collection('quiniela_sponsors').get()
      ]), 8000);
      this.data.matches = matchesSnap.exists ? matchesSnap.data() : JSON.parse(JSON.stringify(MUNDIAL_DATA.partidos));
      this.data.results = resultsSnap.exists ? resultsSnap.data() : {};
      this.data.adminConfig = adminSnap.exists ? adminSnap.data() : { fasesActivas: ['dieciseisavos'], premios: null };
      this._applyPointsConfig(pointsSnap.exists ? pointsSnap.data() : null);
      const sponsors = [];
      sponsorsSnap.forEach(doc => sponsors.push({ id: doc.id, ...doc.data() }));
      this.data.sponsors.title = sponsors.find(s => s.tier === 'title' && s.active !== false) || null;
      this.data.sponsors.banners = sponsors.filter(s => s.tier === 'banner' && s.active !== false)
        .sort((a, b) => (a.order || 0) - (b.order || 0));
    } catch (e) {
      this.data.matches = JSON.parse(JSON.stringify(MUNDIAL_DATA.partidos));
      this.data.results = {};
      this.data.adminConfig = { fasesActivas: ['dieciseisavos'], premios: null };
      if (this.isSessionError(e)) return this.handleSessionExpired();
      this.toast('No se pudo conectar. Verifica tu internet.', 'error');
    }
  },

  async loadCurrentUser(uid) {
    try {
      const doc = await withTimeout(this.db.collection('users').doc(uid).get(), 6000);
      this.currentUser = doc.exists ? { uid, ...doc.data() } : null;
    } catch (e) {
      this.currentUser = null;
      if (this.isSessionError(e)) this.handleSessionExpired();
    }
  },

  // ── SESIÓN EXPIRADA / REVOCADA ──────────────────────────
  // Si la contraseña se cambió desde otro lado (ej. el enlace de "olvidé mi
  // contraseña"), Firebase revoca la sesión activa. La siguiente lectura a
  // Firestore falla con "permission-denied" o "unauthenticated" — sin esto,
  // el usuario veía un confuso "verifica tu conexión" en vez de algo claro.
  isSessionError(err) {
    const code = err && err.code;
    return code === 'permission-denied' || code === 'unauthenticated' ||
      code === 'auth/user-token-expired' || code === 'auth/user-disabled';
  },

  handleSessionExpired() {
    this.auth.signOut();
    this.currentUser = null;
    this.toast('Tu sesión expiró o cambió desde otro dispositivo. Inicia sesión de nuevo.', 'error');
    this.showScreen('landing');
  },

  // ── ERRORES DE FIREBASE → MENSAJES EN ESPAÑOL ───────────

  firebaseErrorMessage(err) {
    const map = {
      'auth/email-already-in-use': 'Ese email ya está registrado',
      'auth/invalid-email': 'Email no válido',
      'auth/weak-password': 'La contraseña es muy débil (mínimo 6 caracteres)',
      'auth/user-not-found': 'No encontramos una cuenta con ese usuario o email',
      'auth/wrong-password': 'Contraseña incorrecta. Intenta de nuevo.',
      'auth/invalid-credential': 'Usuario o contraseña incorrectos',
      'auth/too-many-requests': 'Demasiados intentos. Espera unos minutos e intenta de nuevo.',
      'auth/network-request-failed': 'Sin conexión a internet. Verifica tu red.',
      'auth/unauthorized-domain': 'Este dominio no está autorizado en Firebase. Avísale al administrador del sitio.',
      'permission-denied': 'Permiso denegado por las reglas de seguridad. Avísale al administrador del sitio.'
    };
    if (err && map[err.code]) return map[err.code];
    // Mostramos el código técnico para poder diagnosticar sin abrir la consola del navegador.
    const code = (err && (err.code || err.message)) || 'desconocido';
    return 'Ocurrió un error (' + code + '). Intenta de nuevo.';
  },

  // ── SESIÓN ──────────────────────────────────────────────

  logout() {
    this.auth.signOut();
    this.currentUser = null;
    this.myPredictions = {};
    this.tempScores = {};
    document.getElementById('sr-q-register-form')?.reset();
    document.getElementById('sr-q-login-form')?.reset();
    this.showScreen('landing');
    this.toast('Sesión cerrada', 'info');
  },

  async forgotPassword() {
    const email = (prompt('Ingresa tu correo electrónico para enviarte el enlace de recuperación:') || '').trim();
    if (!email) return;
    try {
      await this.auth.sendPasswordResetEmail(email);
      this.toast('📧 Te enviamos un correo con instrucciones para restablecer tu contraseña', 'success');
    } catch (err) {
      this.toast(this.firebaseErrorMessage(err), 'error');
    }
  },

  // Funciona igual con mouse (clic) y con dedo (touch en móvil) porque es un
  // <button> nativo — no necesita lógica separada para cada caso.
  togglePasswordVisibility(inputId, btn) {
    const input = document.getElementById(inputId);
    if (!input) return;
    const showing = input.type === 'text';
    input.type = showing ? 'password' : 'text';
    const openIcon = btn.querySelector('.sr-q-eye-open');
    const closedIcon = btn.querySelector('.sr-q-eye-closed');
    if (openIcon) openIcon.style.display = showing ? '' : 'none';
    if (closedIcon) closedIcon.style.display = showing ? 'none' : '';
    btn.setAttribute('aria-label', showing ? 'Mostrar contraseña' : 'Ocultar contraseña');
  },

  // ── PANTALLAS ───────────────────────────────────────────

  async showScreen(screen) {
    document.querySelectorAll('.sr-q-screen').forEach(s => s.classList.remove('active'));
    const target = document.getElementById('sr-q-' + screen);
    if (!target) return;
    target.classList.add('active');
    window.scrollTo({ top: target.offsetTop - 20, behavior: 'smooth' });

    // Resultados, fases activas y premios los administra el panel admin y
    // pueden cambiar en cualquier momento durante el torneo — los recargamos
    // cada vez que el usuario entra a una de estas pantallas, no solo al
    // iniciar sesión, para no quedarnos con datos desactualizados.
    if (this.currentUser && (screen === 'dashboard' || screen === 'ranking' || screen === 'premios' || screen === 'mis-stats' || screen === 'grupo')) {
      await this.loadConfig();
    }

    const renders = {
      dashboard:  () => this.renderDashboard(),
      ranking:    () => this.renderRanking(),
      premios:    () => this.renderPrizes(),
      grupo:      () => this.renderGrupoScreen(),
      'mis-stats':() => this.renderMisStats()
    };
    if (renders[screen]) renders[screen]();
  },

  // ── STATS HERO ──────────────────────────────────────────

  updateHeroStats() {
    const el = document.getElementById('sr-q-total-users');
    if (el) el.textContent = Math.max(0, this.totalUsers || 0);
  },

  // ── REGISTRO ────────────────────────────────────────────

  showRegister() {
    this.showScreen('register');
    document.getElementById('sr-q-register-form')?.reset();
  },
  showLogin() {
    this.showScreen('login');
    document.getElementById('sr-q-login-form')?.reset();
  },

  async register(e) {
    e.preventDefault();
    const form = e.target;
    const get = name => form.querySelector('[name="' + name + '"]')?.value.trim() || '';
    const nombre = get('nombre').slice(0, 60),
          email    = get('email').toLowerCase(),
          username = get('username'),
          password = get('password'),
          pais = get('pais'), seleccion = get('seleccion').slice(0, 40);

    if (!nombre || !email || !username || !password) {
      return this.toast('Completa todos los campos obligatorios', 'error');
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return this.toast('Email no válido', 'error');
    }
    if (username.length < 4) {
      return this.toast('El usuario debe tener al menos 4 caracteres', 'error');
    }
    if (!/^[a-zA-Z0-9_.-]+$/.test(username)) {
      return this.toast('El usuario solo puede contener letras, números, puntos, guiones y _ (no uses tu correo electrónico)', 'error');
    }
    if (password.length < 6) {
      return this.toast('La contraseña debe tener al menos 6 caracteres', 'error');
    }
    const acceptTerms = form.querySelector('#reg-accept-terms');
    if (!acceptTerms || !acceptTerms.checked) {
      return this.toast('Debes leer y aceptar cómo funciona la quiniela y los Términos y Condiciones', 'error');
    }

    const usernameLower = username.toLowerCase();
    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    try {
      const unameDoc = await this.db.collection('usernames').doc(usernameLower).get();
      if (unameDoc.exists) {
        return this.toast('Ese nombre de usuario ya está en uso', 'error');
      }

      const cred = await this.auth.createUserWithEmailAndPassword(email, password);
      const uid = cred.user.uid;

      const profile = {
        nombre, username, usernameLower, email, pais, seleccion,
        avatar: nombre.charAt(0).toUpperCase(),
        createdAt: new Date().toISOString()
      };

      await Promise.all([
        this.db.collection('users').doc(uid).set(profile),
        this.db.collection('usernames').doc(usernameLower).set({ uid, email })
      ]);

      // No dependemos de onAuthStateChanged para esta transición: el perfil
      // recién se terminó de escribir, así que la marcamos como lista aquí mismo.
      // (El contador público de participantes lo recalcula el admin desde la
      // cantidad real de usuarios cada vez que abre su panel — no lo
      // incrementamos aquí para evitar que se desincronice.)
      this.currentUser = { uid, ...profile };
      this.toast('¡Bienvenido ' + nombre + '! ⚽ Ya puedes hacer tus predicciones.', 'success');
      this.showScreen('dashboard'); // showScreen() ya recarga matches/results/admin
    } catch (err) {
      this.toast(this.firebaseErrorMessage(err), 'error');
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  },

  // ── LOGIN ───────────────────────────────────────────────

  async login(e) {
    e.preventDefault();
    const form = e.target;
    const usernameOrEmail = form.querySelector('[name="username"]')?.value.trim() || '';
    const password = form.querySelector('[name="password"]')?.value || '';

    if (!usernameOrEmail) return this.toast('Ingresa tu usuario o email', 'error');
    if (!password) return this.toast('Ingresa tu contraseña', 'error');

    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    try {
      let email = usernameOrEmail.toLowerCase();
      if (!email.includes('@')) {
        const unameDoc = await this.db.collection('usernames').doc(email).get();
        if (!unameDoc.exists) {
          return this.toast('No encontramos una cuenta con ese usuario', 'error');
        }
        email = unameDoc.data().email;
      }

      const cred = await this.auth.signInWithEmailAndPassword(email, password);
      await this.loadCurrentUser(cred.user.uid);
      if (!this.currentUser) {
        return this.toast('No encontramos tu perfil. Contacta soporte.', 'error');
      }
      this.toast('¡Bienvenido de vuelta! ⚽', 'success');
      this.showScreen('dashboard'); // showScreen() ya recarga matches/results/admin
    } catch (err) {
      this.toast(this.firebaseErrorMessage(err), 'error');
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  },

  // ── DASHBOARD ───────────────────────────────────────────

  async renderDashboard() {
    if (!this.currentUser) return this.showScreen('landing');

    const matchesList = document.getElementById('sr-q-matches-list');
    if (matchesList) matchesList.innerHTML = '<div class="sr-q-empty"><p>Cargando tus predicciones…</p></div>';

    this.myPredictions = await this.getMyPredictions();
    const stats = this.calculatePointsFor(this.myPredictions);
    const ranking = await this.getAllUsersWithStats();
    const pos = ranking.findIndex(u => u.uid === this.currentUser.uid) + 1;

    const prevPts = parseInt(localStorage.getItem('sr-q-pts-' + this.currentUser.uid) || '0', 10);
    if (stats.puntos > prevPts && prevPts > 0) {
      setTimeout(() => { this.showFloatingPoints(stats.puntos - prevPts); this.playCelebrationSound(); }, 500);
    }
    localStorage.setItem('sr-q-pts-' + this.currentUser.uid, String(stats.puntos));
    this.checkRankingImprovement(pos);

    const setTxt = (id, v) => { const el = document.getElementById(id); if (el) el.textContent = v; };
    setTxt('sr-q-user-name', this.currentUser.nombre);
    setTxt('sr-q-user-pos', '#' + (pos || '—') + ' / ' + ranking.length);
    setTxt('sr-q-user-pts', stats.puntos);
    setTxt('sr-q-user-hits', stats.aciertos + '/' + Object.keys(this.data.results).length);

    this.renderBadges(stats, pos, ranking);
    this.renderPhaseBanner();
    this.renderPhases();
    this.renderMatches();
    this.renderSponsorTitle();
    this.renderSponsorStrip();
  },

  // ── LOGROS / MEDALLAS ───────────────────────────────────

  _computeExactosAnotadores(predictions, results) {
    let exactos = 0, anotadores = 0;
    Object.keys(results).forEach(matchId => {
      const res = results[matchId];
      const pred = predictions[matchId];
      if (!pred || !res) return;
      if (String(pred.localScore) === String(res.local) &&
          String(pred.awayScore) === String(res.visitante)) exactos++;
      const rs = res.scorers || (res.scorer ? [res.scorer] : []);
      if (pred.scorer && rs.length > 0 && rs.includes(pred.scorer)) anotadores++;
    });
    return { exactos, anotadores };
  },

  renderBadges(stats, pos, ranking) {
    const el = document.getElementById('sr-q-badges');
    if (!el) return;
    const preds = this.myPredictions || {};
    const results = this.data.results || {};
    const { exactos, anotadores } = this._computeExactosAnotadores(preds, results);
    const predsCount = Object.keys(preds).length;
    const badges = [];

    // Posición en ranking
    if (pos === 1)      badges.push({ icon: '🥇', label: 'Líder',     desc: '1er lugar en el ranking' });
    else if (pos <= 3)  badges.push({ icon: '🥉', label: 'Podio',     desc: 'Top 3 del ranking' });
    else if (pos <= 10) badges.push({ icon: '🎖️', label: 'Top 10',   desc: 'Posición ' + pos + ' del ranking' });

    // Racha actual
    if (stats.streak >= 8)      badges.push({ icon: '🔥', label: 'Legendario', desc: 'Racha de ' + stats.streak + ' aciertos seguidos' });
    else if (stats.streak >= 5) badges.push({ icon: '🔥', label: 'En Llamas',  desc: 'Racha de ' + stats.streak + ' aciertos' });
    else if (stats.streak >= 3) badges.push({ icon: '🔥', label: 'En Racha',   desc: 'Racha de ' + stats.streak + ' aciertos' });

    // Marcadores exactos
    if (exactos >= 5)      badges.push({ icon: '⭐', label: 'Clarividente',  desc: exactos + ' marcadores exactos' });
    else if (exactos >= 3) badges.push({ icon: '⭐', label: 'Ojo de Águila', desc: exactos + ' marcadores exactos' });
    else if (exactos >= 1) badges.push({ icon: '⭐', label: 'Exacto',         desc: 'Marcador exacto acertado' });

    // Anotadores
    if (anotadores >= 3)      badges.push({ icon: '⚽', label: 'Descubridor', desc: anotadores + ' anotadores acertados' });
    else if (anotadores >= 1) badges.push({ icon: '⚽', label: 'Anotador',    desc: 'Anotador estrella acertado' });

    // Puntos
    if (stats.puntos >= 100)     badges.push({ icon: '💎', label: '100+ pts', desc: stats.puntos + ' puntos totales' });
    else if (stats.puntos >= 50) badges.push({ icon: '💪', label: '50+ pts',  desc: stats.puntos + ' puntos totales' });

    // Participación
    if (predsCount >= 16)     badges.push({ icon: '🎯', label: 'Dedicado',     desc: predsCount + ' predicciones realizadas' });
    else if (predsCount >= 1) badges.push({ icon: '🏅', label: 'Participante', desc: predsCount + ' predicciones realizadas' });

    if (badges.length === 0) { el.innerHTML = ''; return; }

    el.innerHTML =
      '<div class="sr-q-badges-title">🏆 Mis Logros</div>' +
      '<div class="sr-q-badges-row">' +
        badges.map(b =>
          '<div class="sr-q-badge" title="' + escapeHTML(b.desc) + '">' +
            '<span class="sr-q-badge-icon">' + b.icon + '</span>' +
            '<span class="sr-q-badge-label">' + escapeHTML(b.label) + '</span>' +
          '</div>'
        ).join('') +
      '</div>';
  },

  // ── BANNER NUEVA FASE ────────────────────────────────────

  renderPhaseBanner() {
    const banner = document.getElementById('sr-q-phase-banner');
    if (!banner) return;
    const fasesActivas = this.data.adminConfig.fasesActivas || [];
    const faseOrder = ['dieciseisavos', 'octavos', 'cuartos', 'semifinal', 'tercer_lugar', 'final'];

    // Fase activa más avanzada (mayor índice en faseOrder)
    let newestIdx = -1;
    faseOrder.forEach((fid, idx) => { if (fasesActivas.includes(fid)) newestIdx = idx; });
    if (newestIdx <= 0) { banner.style.display = 'none'; return; }

    const faseId = faseOrder[newestIdx];
    const fase = MUNDIAL_DATA.fases.find(f => f.id === faseId);
    if (!fase) { banner.style.display = 'none'; return; }

    // No mostrar si ya fue cerrado para esta fase
    if (localStorage.getItem('sr-banner-dismissed-' + faseId) === '1') {
      banner.style.display = 'none'; return;
    }

    // Primer partido de esa fase (para countdown) — sort by lockAt, then num
    const partidos = ((this.data.matches && this.data.matches[faseId]) || [])
      .slice().sort((a, b) => {
        if (a.lockAt && b.lockAt) return new Date(a.lockAt) - new Date(b.lockAt);
        if (a.lockAt) return -1;
        if (b.lockAt) return 1;
        return a.num - b.num;
      });
    let dateHtml = fase.fechas ? '📅 ' + fase.fechas : '';
    if (partidos.length && partidos[0].lockAt) {
      const diff = new Date(partidos[0].lockAt) - new Date();
      if (diff > 0) {
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        dateHtml = '⏱️ ' + (d > 0 ? d + 'd ' : '') + h + 'h ' + m + 'm para el 1er partido';
      }
    }

    banner.style.display = '';
    banner.innerHTML =
      '<div class="sr-q-banner-content">' +
        '<span class="sr-q-banner-icon">' + fase.icono + '</span>' +
        '<div class="sr-q-banner-text-wrap">' +
          '<div class="sr-q-banner-chip">🏆 ¡Nueva Fase Abierta!</div>' +
          '<div class="sr-q-banner-title">¡Ya puedes predecir los ' + escapeHTML(fase.nombre) + '!</div>' +
          (dateHtml ? '<div class="sr-q-banner-sub">' + dateHtml + '</div>' : '') +
        '</div>' +
        '<button class="sr-q-btn sr-q-banner-cta" ' +
          'onclick="QuinielaApp.goPhaseBanner(\'' + faseId + '\')">🔥 ¡Predecir ahora!</button>' +
      '</div>' +
      '<button class="sr-q-banner-close" onclick="QuinielaApp.dismissPhaseBanner(\'' + faseId + '\')" ' +
        'aria-label="Cerrar">✕</button>';
  },

  goPhaseBanner(faseId) {
    this.currentPhase = faseId;
    this.dismissPhaseBanner(faseId);
    this.renderPhases();
    this.renderMatches();
  },

  dismissPhaseBanner(faseId) {
    localStorage.setItem('sr-banner-dismissed-' + faseId, '1');
    const banner = document.getElementById('sr-q-phase-banner');
    if (!banner) return;
    banner.classList.add('sr-q-banner-out');
    setTimeout(() => { banner.style.display = 'none'; banner.classList.remove('sr-q-banner-out'); }, 300);
  },

  async getMyPredictions() {
    try {
      const doc = await withTimeout(this.db.collection('predictions').doc(this.currentUser.uid).get(), 6000);
      return doc.exists ? doc.data() : {};
    } catch (e) {
      if (this.isSessionError(e)) this.handleSessionExpired();
      return {};
    }
  },

  // ── FASES ───────────────────────────────────────────────

  renderPhases() {
    const container = document.getElementById('sr-q-phases-tabs');
    if (!container) return;
    container.innerHTML = '';
    const fasesActivas = this.data.adminConfig.fasesActivas || [];

    MUNDIAL_DATA.fases.forEach(fase => {
      const isActive = this.currentPhase === fase.id;
      const isUnlocked = fasesActivas.includes(fase.id);

      const btn = document.createElement('button');
      btn.className = 'sr-q-phase-btn' +
        (isActive ? ' active' : '') +
        (!isUnlocked ? ' locked' : '');
      btn.title = isUnlocked ? fase.fechas : '🔒 No disponible aún';
      btn.innerHTML =
        '<span class="phase-icon">' + fase.icono + '</span>' +
        '<span class="phase-name">' + fase.nombre + '</span>' +
        '<span class="phase-pts">Exacto +' + fase.puntos.exacto + 'pts</span>';

      if (isUnlocked) {
        btn.addEventListener('click', () => {
          this.currentPhase = fase.id;
          this.renderPhases();
          this.renderMatches();
        });
      }
      container.appendChild(btn);
    });
  },

  // ── PARTIDOS ────────────────────────────────────────────

  renderMatches() {
    const container = document.getElementById('sr-q-matches-list');
    if (!container) return;
    container.innerHTML = '';

    const partidos = ((this.data.matches && this.data.matches[this.currentPhase]) || [])
      .slice().sort((a, b) => {
        if (a.lockAt && b.lockAt) {
          const da = new Date(a.lockAt), db = new Date(b.lockAt);
          if (da.toDateString() === db.toDateString()) return a.num - b.num;
          return da - db;
        }
        if (a.lockAt) return -1;
        if (b.lockAt) return 1;
        return a.num - b.num;
      });
    const fase = MUNDIAL_DATA.fases.find(f => f.id === this.currentPhase);

    if (partidos.length === 0) {
      container.innerHTML = '<div class="sr-q-empty"><span class="sr-q-empty-icon">⏳</span><p>Los partidos de esta fase no están disponibles aún.</p></div>';
      return;
    }

    partidos.forEach(partido => {
      const pred = this.getPrediction(partido.id);
      const result = this.data.results[partido.id] || null;
      const card = this.buildMatchCard(partido, pred, result, fase);
      container.appendChild(card);
    });
  },

  buildMatchCard(partido, pred, result, fase) {
    const div = document.createElement('div');
    const isFinished = partido.estado === 'finalizado';
    const isTimeLocked = partido.lockAt && new Date() > new Date(partido.lockAt);
    const isClosed = isFinished || partido.estado === 'bloqueado' || isTimeLocked;

    const isFinal   = fase && fase.id === 'final';
    const isTercero = fase && fase.id === 'tercer_lugar';
    const isSemi    = fase && fase.id === 'semifinal';
    const isEpic    = isFinal || isTercero || isSemi;

    div.className = 'sr-q-match-card' +
      (pred ? ' saved' : '') +
      (isClosed ? ' locked-card' : '') +
      (isFinal ? ' sr-q-match-card--final' : isEpic ? ' sr-q-match-card--epic' : '');
    div.id = 'card-' + partido.id;

    const localIcon = partido.local.escudo
      ? '<img src="' + escapeHTML(partido.local.escudo) + '" alt="' + escapeHTML(partido.local.nombre) + '">'
      : escapeHTML(partido.local.bandera);
    const visitIcon = partido.visitante.escudo
      ? '<img src="' + escapeHTML(partido.visitante.escudo) + '" alt="' + escapeHTML(partido.visitante.nombre) + '">'
      : escapeHTML(partido.visitante.bandera);

    const allPlayers = [
      ...(partido.local.jugadores || []).map(j => ({ ...j, bandera: partido.local.bandera })),
      ...(partido.visitante.jugadores || []).map(j => ({ ...j, bandera: partido.visitante.bandera }))
    ];

    const scorerSelected = this.tempScores[partido.id]?.scorer
      || (pred ? pred.scorer : null);
    const localScore = this.tempScores[partido.id]?.local !== undefined
      ? this.tempScores[partido.id].local
      : (pred ? pred.localScore : 0);
    const awayScore = this.tempScores[partido.id]?.away !== undefined
      ? this.tempScores[partido.id].away
      : (pred ? pred.awayScore : 0);

    let ptsEarned = '';
    if (isFinished && pred && result) {
      const pts = this.calcMatchPoints(pred, result, fase);
      if (pts > 0) ptsEarned = '<div class="sr-q-result-pts">+' + pts + ' puntos ganados ✅</div>';
    }

    div.innerHTML =
      '<div class="sr-q-match-header">' +
        '<span>⚽ PARTIDO ' + partido.num + ' · ' + partido.fecha + ' · ' + partido.hora + '</span>' +
        '<span class="sr-q-match-phase-badge">' + (fase ? fase.icono + ' ' + fase.nombre : '') + '</span>' +
      '</div>' +
      '<div class="sr-q-match-body">' +
        '<div class="sr-q-match-sede">🏟️ ' + this._resolveStadium(partido) + '</div>' +

        (!isClosed && partido.lockAt
          ? '<div class="sr-q-lock-countdown" data-lock-at="' + escapeHTML(partido.lockAt) + '">' +
              '<span class="sr-q-lock-countdown__icon">⏳</span>' +
              '<span class="sr-q-lock-countdown__text">Calculando…</span>' +
            '</div>'
          : '') +

        (isFinal
          ? '<div class="sr-q-final-label">🏆 GRAN FINAL · CAMPEÓN DEL MUNDO 🏆</div>'
          : isTercero
            ? '<div class="sr-q-tercero-label">🥉 TERCER LUGAR · BATALLA POR EL PODIO</div>'
            : isSemi
              ? '<div class="sr-q-epic-label">💥 SEMIFINAL · A UN PASO DE LA GLORIA</div>'
              : '') +

        '<div class="sr-q-teams">' +
          '<div class="sr-q-team">' +
            '<div class="sr-q-team-shield">' + localIcon + '</div>' +
            '<div class="sr-q-team-name">' + escapeHTML(partido.local.nombre) + '</div>' +
          '</div>' +
          '<div class="sr-q-vs">VS</div>' +
          '<div class="sr-q-team">' +
            '<div class="sr-q-team-shield">' + visitIcon + '</div>' +
            '<div class="sr-q-team-name">' + escapeHTML(partido.visitante.nombre) + '</div>' +
          '</div>' +
        '</div>' +

        (isFinished && result
          ? '<div class="sr-q-result-box">' +
              '<div style="font-size:11px;color:#555;letter-spacing:2px;margin-bottom:8px">RESULTADO FINAL</div>' +
              '<div class="sr-q-result-score">' + result.local + ' — ' + result.visitante + '</div>' +
              ((result.scorers && result.scorers.length) || result.scorer ? '<div style="font-size:13px;color:#888;margin-top:6px">⚽ ' + (result.scorers || [result.scorer]).map(s => escapeHTML(s)).join(' · ⚽ ') + '</div>' : '') +
              ptsEarned +
            '</div>'
          : '') +

        (!isClosed
          ? '<div class="sr-q-score-label">PREDICE EL MARCADOR</div>' +
            '<div class="sr-q-score-selector">' +
              '<div class="sr-q-score-input">' +
                '<button class="sr-q-score-btn" onclick="QuinielaApp.changeScore(\'' + partido.id + '\',\'local\',-1)">−</button>' +
                '<span class="sr-q-score-number" id="sl-' + partido.id + '">' + localScore + '</span>' +
                '<button class="sr-q-score-btn" onclick="QuinielaApp.changeScore(\'' + partido.id + '\',\'local\',1)">+</button>' +
              '</div>' +
              '<span class="sr-q-score-dash">—</span>' +
              '<div class="sr-q-score-input">' +
                '<button class="sr-q-score-btn" onclick="QuinielaApp.changeScore(\'' + partido.id + '\',\'away\',-1)">−</button>' +
                '<span class="sr-q-score-number" id="sa-' + partido.id + '">' + awayScore + '</span>' +
                '<button class="sr-q-score-btn" onclick="QuinielaApp.changeScore(\'' + partido.id + '\',\'away\',1)">+</button>' +
              '</div>' +
            '</div>' +

            (allPlayers.length > 0
              ? '<div class="sr-q-scorer-section">' +
                  '<div class="sr-q-scorer-label">⚽ ANOTADOR ESTRELLA <span class="sr-q-scorer-pts">+' + (fase ? fase.puntos.anotador : 2) + ' pts</span></div>' +
                  '<div class="sr-q-scorer-list">' +
                    allPlayers.map(j =>
                      '<div class="sr-q-scorer-option' + (scorerSelected === j.nombre ? ' selected' : '') + '" ' +
                      'data-player="' + escapeHTML(j.nombre) + '" role="button" tabindex="0" ' +
                      'onclick="QuinielaApp.selectScorer(\'' + partido.id + '\',this.dataset.player,this)">' +
                      '<span class="sr-q-scorer-dorsal">' + escapeHTML(j.dorsal) + '</span>' +
                      '<span>' + escapeHTML(j.bandera) + ' ' + escapeHTML(j.nombre) + '</span>' +
                      '</div>'
                    ).join('') +
                  '</div>' +
                '</div>'
              : '') +

            '<button class="sr-q-btn sr-q-btn-primary" style="width:100%;margin-top:16px;justify-content:center" ' +
            'onclick="QuinielaApp.savePrediction(\'' + partido.id + '\')">' +
            (isFinal ? '🏆 GUARDAR MI PREDICCIÓN FINAL' : isTercero ? '🥉 GUARDAR PREDICCIÓN' : isSemi ? '💥 GUARDAR PREDICCIÓN' : '✅ GUARDAR PREDICCIÓN') +
            '</button>'

          : (!isFinished
              ? '<div class="sr-q-empty" style="padding:24px">' +
                  '<p>' + (isTimeLocked
                    ? '🔒 Las predicciones para este partido están cerradas.'
                    : '🔒 Esta fase no está disponible aún. El admin la abrirá próximamente.') +
                  '</p>' +
                '</div>'
              : '')) +

        (pred
          ? '<div class="sr-q-saved-state">' +
              '<span class="sr-q-saved-text">Tu predicción: ' + pred.localScore + ' — ' + pred.awayScore +
              (pred.scorer ? ' · ⚽ ' + escapeHTML(pred.scorer) : '') + '</span>' +
              '<div style="display:flex;align-items:center;gap:8px;flex-shrink:0">' +
                '<span class="sr-q-potential-pts">Hasta <span>' + this.getMaxPts(fase) + '</span> pts</span>' +
                '<button class="sr-q-share-pred-btn" onclick="QuinielaApp.shareMatchPrediction(\'' + partido.id + '\')" title="Compartir predicción">📤</button>' +
              '</div>' +
            '</div>'
          : '') +
      '</div>';

    return div;
  },

  getMaxPts(fase) {
    if (!fase) return 9;
    return fase.puntos.resultado + fase.puntos.exacto + fase.puntos.anotador;
  },

  // ── MIS ESTADÍSTICAS ────────────────────────────────────────

  async renderMisStats() {
    const container = document.getElementById('sr-q-mis-stats-content');
    if (!container) return;
    container.innerHTML = '<div style="text-align:center;padding:60px 24px;color:#555;font-size:14px">Cargando estadísticas…</div>';

    if (!this.currentUser) return this.showScreen('landing');

    const preds   = this.myPredictions && Object.keys(this.myPredictions).length
                    ? this.myPredictions : await this.getMyPredictions();
    const results = this.data.results || {};
    const matches = this.data.matches || {};

    const ranking  = await this.getAllUsersWithStats();
    const myStats  = this.calculatePointsFor(preds);
    const pos      = ranking.findIndex(u => u.uid === this.currentUser.uid) + 1;
    const totalUsers = ranking.length;

    // Recorrido cronológico por fase
    const orderedMatches = [];
    const matchFaseMap   = {};
    MUNDIAL_DATA.fases.forEach(fase => {
      (matches[fase.id] || []).slice().sort((a, b) => a.num - b.num).forEach(m => {
        matchFaseMap[m.id] = fase;
        if (results[m.id]) orderedMatches.push({ m, result: results[m.id], fase, pred: preds[m.id] });
      });
    });

    // Stats detalladas
    let totalFin = orderedMatches.length;
    let correct = 0, exactos = 0, anotadores = 0;
    let streak = 0, maxStreak = 0;
    let ptsResult = 0, ptsExacto = 0, ptsAnotador = 0, ptsRacha = 0;
    let maxPossible = 0;
    const history = [];
    let cumPts = 0;

    orderedMatches.forEach(({ m, result, fase, pred }) => {
      maxPossible += fase.puntos.resultado + fase.puntos.exacto + fase.puntos.anotador;
      const rL = Number(result.local), rA = Number(result.visitante);
      const realRes = rL > rA ? 'H' : rL < rA ? 'A' : 'D';
      const faseName = (fase.nombre || '').replace(' DE FINAL','').replace('GRAN ','');

      if (!pred) {
        streak = 0;
        history.push({ num: m.num, pts: 0, cumPts, hit: false,
          fase: faseName, loc: m.local?.nombre || '?', aw: m.visitante?.nombre || '?',
          rL, rA, pL: null, pA: null, ok: -1 });
        return;
      }

      const pL = Number(pred.localScore), pA = Number(pred.awayScore);
      const predRes = pL > pA ? 'H' : pL < pA ? 'A' : 'D';
      let mPts = 0, ok = 0;

      if (predRes === realRes) {
        mPts += fase.puntos.resultado; ptsResult += fase.puntos.resultado; correct++; ok = 1;
        if (pL === rL && pA === rA) { mPts += fase.puntos.exacto; ptsExacto += fase.puntos.exacto; exactos++; ok = 2; }
        const rScorers = result.scorers || (result.scorer ? [result.scorer] : []);
        if (pred.scorer && rScorers.includes(pred.scorer)) { mPts += fase.puntos.anotador; ptsAnotador += fase.puntos.anotador; anotadores++; }
        streak++; maxStreak = Math.max(maxStreak, streak);
        if (streak === 3) { mPts += RACHA_BONUS.streak3; ptsRacha += RACHA_BONUS.streak3; }
        if (streak === 5) { mPts += RACHA_BONUS.streak5; ptsRacha += RACHA_BONUS.streak5; }
        if (streak === 8) { mPts += RACHA_BONUS.streak8; ptsRacha += RACHA_BONUS.streak8; }
      } else { streak = 0; }
      cumPts += mPts;
      history.push({ num: m.num, pts: mPts, cumPts, hit: mPts > 0,
        fase: faseName, loc: m.local?.nombre || '?', aw: m.visitante?.nombre || '?',
        rL, rA, pL, pA, ok });
    });

    // Stats por fase
    const phaseStats = {};
    MUNDIAL_DATA.fases.forEach(fase => {
      const fm = (matches[fase.id] || []).filter(m => results[m.id]);
      let pc = 0, pe = 0;
      fm.forEach(m => {
        const p = this.calcMatchPoints(preds[m.id], results[m.id], fase);
        if (p > 0) pc++;
        if (preds[m.id] && Number(preds[m.id].localScore) === Number(results[m.id].local) && Number(preds[m.id].awayScore) === Number(results[m.id].visitante)) pe++;
      });
      phaseStats[fase.id] = { total: fm.length, correct: pc, exactos: pe, pct: fm.length ? Math.round((pc / fm.length) * 100) : 0 };
    });

    const accuracyPct = totalFin > 0 ? Math.round((correct / totalFin) * 100) : 0;
    const radarAxes = [
      { label: 'PRECISIÓN',  value: totalFin > 0 ? correct / totalFin : 0 },
      { label: 'EXACTOS',    value: totalFin > 0 ? Math.min(exactos / Math.max(totalFin * 0.3, 1), 1) : 0 },
      { label: 'ANOTADORES', value: totalFin > 0 ? Math.min(anotadores / Math.max(totalFin * 0.25, 1), 1) : 0 },
      { label: 'PUNTOS',     value: maxPossible > 0 ? Math.min(myStats.puntos / maxPossible, 1) : 0 },
      { label: 'RACHA',      value: Math.min(maxStreak / 8, 1) },
      { label: 'VS GRUPO',   value: totalUsers > 0 ? (totalUsers - pos + 1) / Math.max(totalUsers, 1) : 0 }
    ];

    let html = '';

    // Carta de Jugador (estilo FIFA/FUT) — la pieza central y nueva
    html += this._stsPlayerCard(this.currentUser, pos, totalUsers, totalFin, radarAxes);

    // Racha reciente (form guide)
    html += '<div class="sr-q-sts-panel sr-q-sts-panel--wide"><div class="sr-q-sts-panel-title">Racha Reciente</div>' + this._stsFormGuide(history) + '</div>';

    // Hero cards
    html += '<div class="sr-q-sts-hero">';
    html += this._stsCard('🏆', String(myStats.puntos), 'Puntos totales', '#D4A017');
    html += this._stsCard('📍', pos > 0 ? '#' + pos + ' / ' + totalUsers : '—', 'Tu posición', pos === 1 ? '#f5d060' : '#60a5fa');
    html += this._stsCard('✅', correct + '/' + totalFin, 'Aciertos', '#22c55e');
    html += this._stsCard('🔥', String(maxStreak), 'Mejor racha', '#f97316');
    html += '</div>';

    // Row 1: Gauge + Radar
    html += '<div class="sr-q-sts-row">';
    html += '<div class="sr-q-sts-panel"><div class="sr-q-sts-panel-title">Precisión General</div>' + this._stsGauge(accuracyPct, correct, totalFin, exactos, anotadores) + '</div>';
    html += '<div class="sr-q-sts-panel"><div class="sr-q-sts-panel-title">Perfil de Jugador</div>' + this._stsRadar(radarAxes) + '</div>';
    html += '</div>';

    // Area chart
    html += '<div class="sr-q-sts-panel sr-q-sts-panel--wide"><div class="sr-q-sts-panel-title">Evolución de Puntos</div>' + this._stsAreaChart(history) + '</div>';

    // Row 2: Phase bars + Donut
    html += '<div class="sr-q-sts-row">';
    html += '<div class="sr-q-sts-panel"><div class="sr-q-sts-panel-title">Rendimiento por Fase</div>' + this._stsPhasesBars(phaseStats) + '</div>';
    html += '<div class="sr-q-sts-panel"><div class="sr-q-sts-panel-title">Desglose de Puntos</div>' + this._stsDonut(ptsResult, ptsExacto, ptsAnotador, ptsRacha, myStats.puntos) + '</div>';
    html += '</div>';

    // Rival Fantasma — duelo de categorías vs el promedio real del grupo
    html += '<div class="sr-q-sts-panel sr-q-sts-panel--wide"><div class="sr-q-sts-panel-title">🔮 Rival Fantasma — Tú vs "El Promedio"</div>' + this._stsComparativa(ranking, pos, myStats, totalUsers, accuracyPct, this.currentUser.uid) + '</div>';

    container.innerHTML = html;

    // Counter animation for numeric hero values
    container.querySelectorAll('.sr-sts-count').forEach(el => {
      const target = Number(el.dataset.val);
      if (!target) return;
      let cur = 0;
      const step = Math.max(Math.ceil(target / 36), 1);
      const tick = setInterval(() => {
        cur = Math.min(cur + step, target);
        el.textContent = cur;
        if (cur >= target) clearInterval(tick);
      }, 22);
    });

    // Rich tooltips on area chart dots
    this._initChartTooltips(container);
    this.renderSponsorStrip();
  },

  _initChartTooltips(container) {
    const svg = container.querySelector('.sr-sts-chart-svg');
    if (!svg) return;

    // Attach tooltip to body (fixed) so overflow:auto never clips it
    const OLD = document.getElementById('sr-sts-gtip');
    if (OLD) OLD.remove();
    const tip = document.createElement('div');
    tip.id = 'sr-sts-gtip';
    tip.className = 'sr-sts-tooltip';
    tip.style.position = 'fixed';
    document.body.appendChild(tip);

    const buildHtml = (d) => {
      const noPred = d.pL === null || d.pL === undefined;
      const badge  = d.ok === 2 ? { t: '🎯 EXACTO',        c: '#D4A017' }
                   : d.ok === 1 ? { t: '✅ RESULTADO',      c: '#22c55e' }
                   : noPred      ? { t: '⚠️ SIN VATICINIO', c: '#666'   }
                   :               { t: '❌ FALLADO',        c: '#ef4444' };
      const predTxt   = noPred ? '—' : d.pL + ' – ' + d.pA;
      const resultTxt = d.rL  + ' – ' + d.rA;
      const resColor  = d.ok === 2 ? '#D4A017' : d.ok === 1 ? '#22c55e' : '#fff';

      return (
        '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:9px;letter-spacing:2px;color:#555;margin-bottom:6px">' +
          escapeHTML(d.fase || '') + ' · PARTIDO ' + d.num +
        '</div>' +
        '<div style="font-size:14px;font-weight:700;color:#fff;margin-bottom:12px;line-height:1.25">' +
          escapeHTML(d.loc || '') +
          '<span style="color:#3a3a3a;font-weight:400;margin:0 6px">vs</span>' +
          escapeHTML(d.aw || '') +
        '</div>' +
        '<div style="display:grid;grid-template-columns:1fr 1fr;gap:7px;margin-bottom:12px">' +
          '<div style="background:#101010;border-radius:9px;padding:8px 10px;border:1px solid #222">' +
            '<div style="font-size:8px;color:#444;letter-spacing:1.2px;text-transform:uppercase;margin-bottom:4px">Tu vaticinio</div>' +
            '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:22px;line-height:1;color:' + (noPred ? '#2a2a2a' : '#fff') + '">' + predTxt + '</div>' +
          '</div>' +
          '<div style="background:#101010;border-radius:9px;padding:8px 10px;border:1px solid #222">' +
            '<div style="font-size:8px;color:#444;letter-spacing:1.2px;text-transform:uppercase;margin-bottom:4px">Resultado</div>' +
            '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:22px;line-height:1;color:' + resColor + '">' + resultTxt + '</div>' +
          '</div>' +
        '</div>' +
        '<div style="display:flex;align-items:center;justify-content:space-between;padding-top:9px;border-top:1px solid #1c1c1c">' +
          '<span style="font-size:11px;font-weight:700;color:' + badge.c + ';letter-spacing:0.3px">' + badge.t + '</span>' +
          '<span style="font-size:11px;color:#555;font-variant-numeric:tabular-nums">' +
            (d.pts > 0 ? '<strong style="color:#D4A017;margin-right:5px">+' + d.pts + ' pts</strong>' : '<span style="margin-right:5px">0 pts</span>') +
            '| <span style="color:#444">' + d.cum + ' total</span>' +
          '</span>' +
        '</div>'
      );
    };

    const showTip = (clientX, clientY, dot) => {
      let d;
      try { d = JSON.parse(decodeURIComponent(dot.dataset.info || '')); } catch(e) { return; }
      tip.innerHTML = buildHtml(d);
      tip.classList.add('visible');

      // Position using fixed coords (viewport-relative — never clipped)
      const vw = window.innerWidth, vh = window.innerHeight;
      const tw = tip.offsetWidth  || 234;
      const th = tip.offsetHeight || 185;
      let lft  = clientX + 16;
      let top  = clientY - th - 16;
      if (lft + tw > vw - 8) lft = clientX - tw - 16;  // flip left
      if (top < 8)           top = clientY + 16;         // flip down
      lft = Math.max(8, Math.min(lft, vw - tw - 8));
      top = Math.max(8, Math.min(top, vh - th - 8));
      tip.style.left = lft + 'px';
      tip.style.top  = top + 'px';
    };

    const hideTip = () => tip.classList.remove('visible');

    // Desktop
    svg.addEventListener('mousemove', e => {
      const dot = e.target.closest ? e.target.closest('.sr-sts-dot') : null;
      if (dot) showTip(e.clientX, e.clientY, dot);
      else hideTip();
    });
    svg.addEventListener('mouseleave', hideTip);
    document.addEventListener('scroll', hideTip, { passive: true });

    // Mobile — tap dot → show 3s then hide
    let mobileTimer;
    svg.addEventListener('touchstart', e => {
      const t = e.touches[0];
      const el = document.elementFromPoint(t.clientX, t.clientY);
      const dot = el && (el.classList.contains('sr-sts-dot') ? el : (el.closest ? el.closest('.sr-sts-dot') : null));
      if (dot) {
        e.preventDefault();
        clearTimeout(mobileTimer);
        showTip(t.clientX, t.clientY, dot);
        mobileTimer = setTimeout(hideTip, 3000);
      } else { hideTip(); }
    }, { passive: false });

    // Cleanup when screen changes
    const obs = new MutationObserver(() => {
      if (!document.body.contains(svg)) { hideTip(); tip.remove(); obs.disconnect(); }
    });
    obs.observe(document.body, { childList: true, subtree: false });
  },

  _stsCard(icon, value, label, color) {
    const isNum = /^\d+$/.test(value);
    const inner = isNum
      ? '<span class="sr-sts-count" data-val="' + value + '" style="color:' + color + '">0</span>'
      : '<span style="color:' + color + '">' + escapeHTML(value) + '</span>';
    return '<div class="sr-q-sts-card">' +
      '<div class="sr-q-sts-card-icon">' + icon + '</div>' +
      '<div class="sr-q-sts-card-value">' + inner + '</div>' +
      '<div class="sr-q-sts-card-label">' + escapeHTML(label) + '</div>' +
    '</div>';
  },

  // ── CARTA DE JUGADOR (estilo FIFA/FUT) ──────────────────
  _stsPlayerCard(user, pos, totalUsers, totalFin, radarAxes) {
    const uid = 'pc' + Math.random().toString(36).slice(2, 7);
    const nombre = (user && user.nombre) ? user.nombre : 'Jugador';
    const seleccion = (user && user.seleccion) ? user.seleccion : '';
    const initials = nombre.trim().split(/\s+/).slice(0, 2).map(w => w[0]).join('').toUpperCase() || '?';

    if (totalFin === 0) {
      return '<div class="sr-q-pcard-wrap" style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;' +
        'background:linear-gradient(150deg,#161616 0%,#0d0d0d 100%);border:1px dashed rgba(255,255,255,0.15);border-radius:20px;' +
        'padding:36px 20px;margin-bottom:14px;text-align:center">' +
        '<div style="font-size:34px;opacity:0.5">🃏</div>' +
        '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:17px;letter-spacing:1.5px;color:#888">TU CARTA SE ESTÁ FORJANDO</div>' +
        '<div style="font-size:12px;color:#555;max-width:280px">Se revelará tu rating en cuanto termine el primer partido con resultado.</div>' +
      '</div>';
    }

    // radarAxes: [PRECISIÓN, EXACTOS, ANOTADORES, PUNTOS, RACHA, VS GRUPO]
    const av = v => Math.round(Math.max(Math.min(v, 1), 0) * 99);
    const pre = av(radarAxes[0].value);
    const exa = av(radarAxes[1].value);
    const gol = av(radarAxes[2].value);
    const rac = av(radarAxes[4].value);
    const gru = av(radarAxes[5].value);
    const ovr = Math.round(pre * 0.40 + exa * 0.25 + gol * 0.15 + rac * 0.10 + gru * 0.10);

    const tiers = [
      { min: 85, name: 'ÉLITE',  grad: 'linear-gradient(150deg,#050505 0%,#2a1f00 45%,#D4A017 100%)', border: '#f5d060', ink: '#f5d060', sub: 'rgba(245,208,96,0.75)' },
      { min: 75, name: 'ORO',    grad: 'linear-gradient(150deg,#5a4200 0%,#D4A017 55%,#f7dd8a 100%)', border: '#f7dd8a', ink: '#241a00', sub: 'rgba(36,26,0,0.65)' },
      { min: 60, name: 'PLATA',  grad: 'linear-gradient(150deg,#4a4a52 0%,#a8a8b2 55%,#e8e8ee 100%)', border: '#e8e8ee', ink: '#1a1a1a', sub: 'rgba(26,26,26,0.6)' },
      { min: 0,  name: 'BRONCE', grad: 'linear-gradient(150deg,#3a2410 0%,#8a5a2e 55%,#cd9a5c 100%)', border: '#cd9a5c', ink: '#241608', sub: 'rgba(36,22,8,0.6)' }
    ];
    const tier = tiers.find(t => ovr >= t.min);

    // Arquetipo — la mejor cualidad del jugador, como un puesto de scouting
    const arche = [
      { key: 'pre', v: pre, label: 'EL CONSISTENTE', icon: '🧠' },
      { key: 'exa', v: exa, label: 'EL FRANCOTIRADOR', icon: '🎯' },
      { key: 'gol', v: gol, label: 'EL VIDENTE', icon: '🔮' },
      { key: 'rac', v: rac, label: 'EL HOT STREAK', icon: '🔥' },
      { key: 'gru', v: gru, label: 'EL LÍDER', icon: '👑' }
    ].sort((a, b) => b.v - a.v)[0];

    const attr = (label, val) =>
      '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px;padding:5px 0">' +
        '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:16px;color:' + tier.ink + ';min-width:26px">' + val + '</span>' +
        '<span style="font-size:9.5px;letter-spacing:1.2px;color:' + tier.sub + ';font-weight:700">' + label + '</span>' +
      '</div>';

    return '<style>' +
      '@keyframes ' + uid + '_in{from{opacity:0;transform:translateY(18px) scale(0.97) rotateX(8deg)}to{opacity:1;transform:translateY(0) scale(1) rotateX(0)}}' +
      '.' + uid + '{animation:' + uid + '_in 0.55s cubic-bezier(0.22,1,0.36,1) backwards;perspective:800px}' +
      '.' + uid + '_shine{position:absolute;inset:0;border-radius:20px;pointer-events:none;' +
        'background:linear-gradient(115deg,transparent 20%,rgba(255,255,255,0.35) 34%,transparent 48%);' +
        'transform:translateX(-120%);transition:transform 0.85s ease}' +
      '.' + uid + ':hover .' + uid + '_shine{transform:translateX(120%)}' +
      '.' + uid + ':hover{transform:translateY(-3px)}' +
    '</style>' +
    '<div class="sr-q-pcard-wrap ' + uid + '" style="position:relative;overflow:hidden;border-radius:20px;padding:22px 22px 18px;' +
      'margin-bottom:14px;background:' + tier.grad + ';border:1px solid ' + tier.border + ';' +
      'box-shadow:0 10px 34px rgba(0,0,0,0.55),inset 0 1px 0 rgba(255,255,255,0.25);transition:transform 0.25s">' +
      '<div class="' + uid + '_shine"></div>' +
      '<div style="display:flex;gap:18px;align-items:stretch;flex-wrap:wrap;position:relative;z-index:1">' +
        // Columna izquierda: OVR + tier + avatar
        '<div style="display:flex;flex-direction:column;align-items:center;min-width:86px">' +
          '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:52px;line-height:0.9;color:' + tier.ink + '">' + ovr + '</div>' +
          '<div style="font-size:10px;letter-spacing:2.5px;font-weight:800;color:' + tier.ink + ';opacity:0.85;margin-top:2px">' + tier.name + '</div>' +
          '<div style="width:56px;height:56px;border-radius:50%;background:rgba(0,0,0,0.18);border:2px solid ' + tier.ink + ';' +
            'display:flex;align-items:center;justify-content:center;margin-top:10px;font-family:\'Bebas Neue\',sans-serif;font-size:20px;color:' + tier.ink + '">' +
            escapeHTML(initials) +
          '</div>' +
        '</div>' +
        // Columna central: atributos tipo FIFA
        '<div style="flex:1;min-width:150px;display:grid;grid-template-columns:1fr 1fr;gap:0 14px;' +
          'border-left:1px solid rgba(0,0,0,0.15);border-right:1px solid rgba(0,0,0,0.15);padding:0 16px">' +
          '<div>' + attr('PRE', pre) + attr('EXA', exa) + attr('GOL', gol) + '</div>' +
          '<div>' + attr('RAC', rac) + attr('GRU', gru) + '</div>' +
        '</div>' +
        // Columna derecha: identidad
        '<div style="min-width:130px;display:flex;flex-direction:column;justify-content:center;gap:4px">' +
          '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:19px;color:' + tier.ink + ';line-height:1.05;word-break:break-word">' + escapeHTML(nombre) + '</div>' +
          '<div style="font-size:10.5px;color:' + tier.sub + ';font-weight:700">' + arche.icon + ' ' + arche.label + '</div>' +
          (seleccion ? '<div style="font-size:10px;color:' + tier.sub + '">⚽ ' + escapeHTML(seleccion) + '</div>' : '') +
          '<div style="font-size:10px;color:' + tier.sub + ';margin-top:2px">#' + (pos > 0 ? pos : '—') + ' de ' + totalUsers + ' participantes</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  },

  // ── RACHA RECIENTE (form guide) ──────────────────────────
  _stsFormGuide(history) {
    if (!history || history.length === 0) {
      return '<div style="color:#444;font-size:13px;padding:6px 0">Tu racha de aciertos/fallos aparecerá aquí partido a partido.</div>';
    }
    const recent = history.slice(-10);
    const pills = recent.map((h, i) => {
      let bg, border, glyph;
      if (h.ok === 2)      { bg = '#D4A017'; border = '#f5d060'; glyph = '★'; }
      else if (h.ok === 1) { bg = '#1c3a24'; border = '#22c55e'; glyph = '✓'; }
      else if (h.ok === -1){ bg = 'transparent'; border = '#333'; glyph = '–'; }
      else                 { bg = '#3a1414'; border = '#ef4444'; glyph = '✕'; }
      const color = h.ok === 2 ? '#241a00' : (h.ok === 1 ? '#22c55e' : (h.ok === -1 ? '#444' : '#ef4444'));
      const title = 'Partido ' + h.num + ': ' + h.loc + ' ' + h.rL + '-' + h.rA + ' ' + h.aw +
        (h.pts > 0 ? ' · +' + h.pts + ' pts' : '');
      const delay = (i * 0.05).toFixed(2);
      return '<div title="' + escapeHTML(title) + '" style="display:flex;flex-direction:column;align-items:center;gap:4px;flex-shrink:0">' +
        '<div class="sr-sts-fg-pill" style="width:30px;height:30px;border-radius:50%;background:' + bg + ';border:2px solid ' + border + ';' +
          'display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:800;color:' + color + ';' +
          'animation-delay:' + delay + 's">' + glyph + '</div>' +
        '<span style="font-size:8px;color:#3a3a3a">P' + h.num + '</span>' +
      '</div>';
    }).join('<div style="flex-shrink:0;height:2px;width:10px;background:#222;align-self:center;margin-top:13px"></div>');

    // Racha de aciertos en curso (contando desde el final hacia atrás)
    let live = 0;
    for (let i = recent.length - 1; i >= 0; i--) {
      if (recent[i].ok === 1 || recent[i].ok === 2) live++; else break;
    }
    const liveTag = live >= 3
      ? '<div style="margin-top:14px;display:inline-flex;align-items:center;gap:6px;background:rgba(249,115,22,0.12);' +
        'border:1px solid rgba(249,115,22,0.4);border-radius:20px;padding:6px 14px;font-size:12px;color:#f97316;font-weight:700">' +
        '🔥 ¡' + live + ' aciertos seguidos ahora mismo!</div>'
      : '';

    return '<div style="display:flex;gap:8px;overflow-x:auto;padding:2px 2px 6px">' + pills + '</div>' + liveTag;
  },

  _stsGauge(pct, correct, total, exactos, anotadores) {
    const r = 72, cx = 92, cy = 92;
    const circ = 2 * Math.PI * r;
    const dash  = Math.max((pct / 100) * circ, 0).toFixed(1);
    const color  = pct >= 60 ? '#22c55e' : pct >= 35 ? '#D4A017' : '#ef4444';
    const bgFill = pct >= 60 ? '#041206' : pct >= 35 ? '#150e00' : '#140404';
    const uid = 'gr' + Math.random().toString(36).slice(2, 7);

    const chip = (icon, val, label, col) =>
      '<div style="flex:1;min-width:0;background:#0e0e0e;border:1px solid #222;border-radius:10px;padding:10px 8px;text-align:center">' +
        '<div style="font-size:16px;line-height:1;margin-bottom:4px">' + icon + '</div>' +
        '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:22px;color:' + col + ';line-height:1;font-variant-numeric:tabular-nums">' + val + '</div>' +
        '<div style="font-size:9px;color:#555;letter-spacing:1px;text-transform:uppercase;margin-top:3px">' + label + '</div>' +
      '</div>';

    const totalCirc = Math.ceil(circ);
    return '<style>' +
      '@keyframes ' + uid + '{from{stroke-dasharray:0 ' + totalCirc + '}to{stroke-dasharray:' + dash + ' ' + totalCirc + '}}' +
      '.' + uid + '{animation:' + uid + ' 1.4s cubic-bezier(0.22,1,0.36,1) 0.35s both}' +
    '</style>' +
    '<div style="display:flex;flex-direction:column;align-items:center;gap:16px;padding:4px 0">' +
      '<svg viewBox="0 0 184 184" width="184" height="184">' +
        '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="' + bgFill + '" stroke="#1c1c1c" stroke-width="14"/>' +
        '<circle class="' + uid + '" cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="none" stroke="' + color + '" stroke-width="14"' +
          ' stroke-dasharray="0 ' + totalCirc + '" stroke-linecap="round"' +
          ' transform="rotate(-90 ' + cx + ' ' + cy + ')"/>' +
        '<text x="' + cx + '" y="' + (cy - 10) + '" text-anchor="middle" font-family="Bebas Neue,sans-serif" font-size="46" fill="#fff">' + pct + '%</text>' +
        '<text x="' + cx + '" y="' + (cy + 16) + '" text-anchor="middle" font-size="11" fill="#555" letter-spacing="2.5">ACIERTOS</text>' +
        '<text x="' + cx + '" y="' + (cy + 36) + '" text-anchor="middle" font-size="10" fill="#3a3a3a">' + correct + ' / ' + total + ' partidos</text>' +
      '</svg>' +
      '<div style="display:flex;gap:8px;width:100%">' +
        chip('🎯', String(exactos || 0),    'Exactos',    '#D4A017') +
        chip('⚽', String(anotadores || 0), 'Anotadores', '#22c55e') +
        chip('📊', (total > 0 ? Math.round((correct / total) * 100) : 0) + '%', 'Precisión', color) +
      '</div>' +
    '</div>';
  },

  _stsRadar(axes) {
    const cx = 120, cy = 120, r = 80, n = axes.length;
    const angle = i => (i / n) * 2 * Math.PI - Math.PI / 2;
    const pt = (i, f) => ({ x: cx + Math.cos(angle(i)) * r * f, y: cy + Math.sin(angle(i)) * r * f });

    const rings = [0.25, 0.5, 0.75, 1].map(f => {
      const pts = axes.map((_, i) => { const p = pt(i, f); return p.x.toFixed(1) + ',' + p.y.toFixed(1); }).join(' ');
      return '<polygon points="' + pts + '" fill="none" stroke="' + (f === 1 ? '#333' : '#1e1e1e') + '" stroke-width="' + (f === 1 ? 1.5 : 0.8) + '"/>';
    }).join('');

    const axisLines = axes.map((_, i) => {
      const p = pt(i, 1);
      return '<line x1="' + cx + '" y1="' + cy + '" x2="' + p.x.toFixed(1) + '" y2="' + p.y.toFixed(1) + '" stroke="#252525" stroke-width="1"/>';
    }).join('');

    const dataPts = axes.map((ax, i) => {
      const v = Math.max(Math.min(ax.value, 1), 0);
      const p = pt(i, v || 0.02);
      return p.x.toFixed(1) + ',' + p.y.toFixed(1);
    }).join(' ');

    const refPts = axes.map((_, i) => { const p = pt(i, 0.5); return p.x.toFixed(1) + ',' + p.y.toFixed(1); }).join(' ');

    const labels = axes.map((ax, i) => {
      const p = pt(i, 1.3);
      const pct = Math.round(Math.max(Math.min(ax.value, 1), 0) * 100);
      return '<text x="' + p.x.toFixed(1) + '" y="' + (p.y - 5).toFixed(1) + '" text-anchor="middle" dominant-baseline="middle"' +
        ' font-size="9" fill="#888" letter-spacing="0.5">' + escapeHTML(ax.label) + '</text>' +
        '<text x="' + p.x.toFixed(1) + '" y="' + (p.y + 8).toFixed(1) + '" text-anchor="middle" dominant-baseline="middle"' +
        ' font-family="Bebas Neue,sans-serif" font-size="11" fill="#D4A017">' + pct + '%</text>';
    }).join('');

    const dots = axes.map((ax, i) => {
      const v = Math.max(Math.min(ax.value, 1), 0);
      const p = pt(i, v || 0.02);
      return '<circle cx="' + p.x.toFixed(1) + '" cy="' + p.y.toFixed(1) + '" r="4" fill="#D4A017" stroke="rgba(0,0,0,0.4)" stroke-width="1.5"/>';
    }).join('');

    return '<div style="display:flex;justify-content:center;align-items:center">' +
      '<svg viewBox="0 0 240 240" width="100%" style="max-width:260px">' +
        rings + axisLines +
        '<polygon points="' + refPts + '" fill="rgba(255,255,255,0.02)" stroke="#2a2a2a" stroke-width="1" stroke-dasharray="3,3"/>' +
        '<polygon points="' + dataPts + '" fill="rgba(212,160,23,0.2)" stroke="#D4A017" stroke-width="2.5"/>' +
        dots + labels +
      '</svg>' +
    '</div>';
  },

  _stsAreaChart(history) {
    if (history.length === 0) {
      return '<div style="text-align:center;padding:32px;color:#444;font-size:13px">Los partidos finalizados aparecerán aquí</div>';
    }
    const W = 540, H = 160, PL = 36, PR = 14, PT = 10, PB = 28;
    const IW = W - PL - PR, IH = H - PT - PB;
    const n = history.length;
    const maxPts = Math.max.apply(null, history.map(h => h.cumPts).concat([1]));

    const px = i => PL + (n === 1 ? IW / 2 : (i / (n - 1)) * IW);
    const py = v => PT + IH - (v / maxPts) * IH;

    const polyPts = history.map((h, i) => px(i).toFixed(1) + ',' + py(h.cumPts).toFixed(1)).join(' ');
    const areaPath = 'M' + px(0).toFixed(1) + ',' + (PT + IH).toFixed(1) + ' ' +
      history.map((h, i) => 'L' + px(i).toFixed(1) + ',' + py(h.cumPts).toFixed(1)).join(' ') +
      ' L' + px(n - 1).toFixed(1) + ',' + (PT + IH).toFixed(1) + ' Z';

    const yTicks = [0, Math.round(maxPts / 2), maxPts];
    const yGrid = yTicks.map(v =>
      '<line x1="' + PL + '" y1="' + py(v).toFixed(1) + '" x2="' + (W - PR) + '" y2="' + py(v).toFixed(1) + '" stroke="#1a1a1a" stroke-width="1"/>' +
      '<text x="' + (PL - 4) + '" y="' + (py(v) + 4).toFixed(1) + '" text-anchor="end" font-size="9" fill="#444">' + v + '</text>'
    ).join('');

    const xIdxs = n <= 3 ? history.map((_, i) => i) : [0, Math.floor((n - 1) / 2), n - 1];
    const xLabels = xIdxs.map(i =>
      '<text x="' + px(i).toFixed(1) + '" y="' + (H - 5) + '" text-anchor="middle" font-size="9" fill="#444">P' + history[i].num + '</text>'
    ).join('');

    const dots = history.map((h, i) => {
      const info = encodeURIComponent(JSON.stringify({
        num: h.num, pts: h.pts, cum: h.cumPts,
        fase: h.fase || '', loc: h.loc || '', aw: h.aw || '',
        rL: h.rL, rA: h.rA, pL: h.pL, pA: h.pA, ok: h.ok
      }));
      const hitR = 10; // invisible large touch/hover area
      const visR = h.pts > 0 ? 4.5 : 2.5;
      const fill = h.pts > 0 ? '#D4A017' : '#252525';
      const cx = px(i).toFixed(1), cy = py(h.cumPts).toFixed(1);
      return '<circle class="sr-sts-dot" data-info="' + info + '" cx="' + cx + '" cy="' + cy + '" r="' + hitR + '" fill="transparent" stroke="none"/>' +
             '<circle cx="' + cx + '" cy="' + cy + '" r="' + visR + '" fill="' + fill + '" stroke="#0a0a0a" stroke-width="1.5" style="pointer-events:none"/>';
    }).join('');

    return '<div class="sr-sts-chart-wrap" style="overflow-x:auto;position:relative">' +
      '<svg class="sr-sts-chart-svg" viewBox="0 0 ' + W + ' ' + H + '" width="100%" style="min-width:260px;overflow:visible">' +
        '<defs><linearGradient id="sg1" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#D4A017" stop-opacity="0.35"/>' +
          '<stop offset="100%" stop-color="#D4A017" stop-opacity="0.02"/>' +
        '</linearGradient></defs>' +
        yGrid + xLabels +
        '<path d="' + areaPath + '" fill="url(#sg1)"/>' +
        '<polyline points="' + polyPts + '" fill="none" stroke="#D4A017" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        dots +
      '</svg>' +
    '</div>';
  },

  _stsPhasesBars(phaseStats) {
    const active = MUNDIAL_DATA.fases.filter(f => phaseStats[f.id] && phaseStats[f.id].total > 0);
    if (active.length === 0) return '<div style="color:#444;font-size:13px;padding:16px 0">Aún no hay fases completadas.</div>';

    return active.map((fase, i) => {
      const s   = phaseStats[fase.id];
      const pct = s.pct;
      const col = pct >= 65 ? '#22c55e' : pct >= 40 ? '#D4A017' : '#ef4444';
      const name = fase.nombre.replace(' DE FINAL', '').replace('GRAN ', '');
      const delay = (0.28 + i * 0.1).toFixed(2);
      return '<div style="margin-bottom:13px">' +
        '<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:5px">' +
          '<span style="font-size:10px;letter-spacing:1px;color:#777;font-weight:600;text-transform:uppercase">' + escapeHTML(name) + '</span>' +
          '<span style="font-size:11px;color:#888">' + s.correct + '/' + s.total +
            ' &nbsp;<strong style="color:' + col + ';font-variant-numeric:tabular-nums">' + pct + '%</strong>' +
          '</span>' +
        '</div>' +
        '<div style="height:7px;background:#1e1e1e;border-radius:5px;overflow:hidden">' +
          '<div class="sr-sts-bar-fill" style="height:100%;width:' + pct + '%;background:' + col + ';border-radius:5px;animation-delay:' + delay + 's"></div>' +
        '</div>' +
      '</div>';
    }).join('');
  },

  _stsDonut(ptsResult, ptsExacto, ptsAnotador, ptsRacha, total) {
    if (total === 0) return '<div style="color:#444;font-size:13px;padding:24px;text-align:center">Aún sin puntos acumulados</div>';
    const allSegs = [
      { label: 'Resultado', value: ptsResult,   color: '#3b82f6' },
      { label: 'Exacto',    value: ptsExacto,   color: '#D4A017' },
      { label: 'Anotador',  value: ptsAnotador, color: '#22c55e' },
      { label: 'Racha',     value: ptsRacha,    color: '#f97316' }
    ];
    const segs   = allSegs.filter(s => s.value > 0);
    if (segs.length === 0) return '<div style="color:#444;font-size:13px;padding:24px;text-align:center">Sin datos</div>';

    const cx = 96, cy = 96, r = 76, inner = 48;
    const totalV = segs.reduce((s, g) => s + g.value, 0);
    let sa = -Math.PI / 2;
    const paths = segs.map((seg, idx) => {
      const pct = seg.value / totalV;
      const ea  = sa + pct * 2 * Math.PI;
      const gap = 0.022;
      const a1 = sa + gap, a2 = ea - gap;
      const x1 = cx + Math.cos(a1) * r,     y1 = cy + Math.sin(a1) * r;
      const x2 = cx + Math.cos(a2) * r,     y2 = cy + Math.sin(a2) * r;
      const i1 = cx + Math.cos(a1) * inner, j1 = cy + Math.sin(a1) * inner;
      const i2 = cx + Math.cos(a2) * inner, j2 = cy + Math.sin(a2) * inner;
      const lg = pct > 0.5 ? 1 : 0;
      const d = 'M' + x1.toFixed(1) + ',' + y1.toFixed(1) +
        ' A' + r + ',' + r + ' 0 ' + lg + ' 1 ' + x2.toFixed(1) + ',' + y2.toFixed(1) +
        ' L' + i2.toFixed(1) + ',' + j2.toFixed(1) +
        ' A' + inner + ',' + inner + ' 0 ' + lg + ' 0 ' + i1.toFixed(1) + ',' + j1.toFixed(1) + ' Z';
      sa = ea;
      const pctLabel = Math.round(pct * 100);
      return '<path class="sr-sts-donut-path" d="' + d + '" fill="' + seg.color + '"' +
        ' style="animation-delay:' + (0.3 + idx * 0.09) + 's">' +
        '<title>' + escapeHTML(seg.label) + ': ' + seg.value + ' pts (' + pctLabel + '%)</title>' +
      '</path>';
    }).join('');

    // legend chips: 2 columns
    const chips = allSegs.map(s => {
      const pct  = totalV > 0 ? Math.round((s.value / totalV) * 100) : 0;
      const hasVal = s.value > 0;
      return '<div class="sr-sts-chip" title="' + escapeHTML(s.label) + ': ' + s.value + ' pts" style="display:flex;align-items:center;gap:10px;padding:10px 12px;background:#0d0d0d;border-radius:10px;border-left:3px solid ' + (hasVal ? s.color : '#222') + '">' +
        '<div style="min-width:0;flex:1">' +
          '<div style="font-size:9px;color:#555;letter-spacing:1px;text-transform:uppercase;margin-bottom:2px">' + escapeHTML(s.label) + '</div>' +
          '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:20px;color:' + (hasVal ? '#fff' : '#333') + ';line-height:1;font-variant-numeric:tabular-nums">' + (s.value || '—') + (hasVal ? ' pts' : '') + '</div>' +
        '</div>' +
        (hasVal ? '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:16px;color:' + s.color + ';opacity:0.8;flex-shrink:0">' + pct + '%</div>' : '') +
      '</div>';
    }).join('');

    return '<div style="display:flex;flex-direction:column;align-items:center;gap:20px">' +
      '<svg viewBox="0 0 192 192" width="170" height="170">' +
        '<circle cx="' + cx + '" cy="' + cy + '" r="' + inner + '" fill="#0a0a0a"/>' +
        paths +
        '<text x="' + cx + '" y="' + (cy - 4) + '" text-anchor="middle" font-family="Bebas Neue,sans-serif" font-size="38" fill="#fff">' + total + '</text>' +
        '<text x="' + cx + '" y="' + (cy + 18) + '" text-anchor="middle" font-size="10" fill="#444" letter-spacing="2">PUNTOS</text>' +
      '</svg>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;width:100%">' + chips + '</div>' +
    '</div>';
  },

  _stsComparativa(ranking, pos, myStats, totalUsers, accuracyPct, myUid) {
    if (totalUsers === 0) return '<div style="color:#444;font-size:13px">No hay otros participantes aún — el rival fantasma nace cuando se una alguien más.</div>';

    const rivals = ranking.filter(u => u.uid !== myUid);
    const myPts = myStats.puntos, myStreak = myStats.streak || 0;

    const sorted   = ranking.map(u => u.puntos).sort((a, b) => b - a);
    const topPts   = sorted[0] || 0;
    const maxRef   = Math.max(topPts, myPts, 1);
    const pctile   = Math.round(((totalUsers - pos) / Math.max(totalUsers - 1, 1)) * 100);
    const pctColor = pctile >= 75 ? '#22c55e' : pctile >= 50 ? '#D4A017' : pctile >= 25 ? '#f97316' : '#ef4444';
    const pctLabel = pctile >= 75 ? 'Top ' + (100 - pctile) + '%' : pctile >= 50 ? 'Sobre la media' : pctile >= 25 ? 'Cerca de la media' : 'Bajo la media';

    // "El Promedio" — un rival fantasma compuesto por TODOS los demás participantes
    const mean = arr => arr.length ? arr.reduce((s, v) => s + v, 0) / arr.length : 0;
    const ghostPool = rivals.length ? rivals : ranking;
    const ghostPts    = Math.round(mean(ghostPool.map(u => u.puntos)));
    const ghostAccPct = Math.round(mean(ghostPool.map(u => u.total > 0 ? (u.aciertos / u.total) * 100 : 0)));
    const ghostStreak = Math.round(mean(ghostPool.map(u => u.streak || 0)) * 10) / 10;

    const bar = (lbl, val, fillColor, textColor, labelColor, suffix) => {
      const w = Math.max((val / maxRef) * 100, 1).toFixed(1);
      return '<div style="display:flex;align-items:center;gap:12px;margin-bottom:12px">' +
        '<div style="width:88px;text-align:right;font-size:11px;color:' + labelColor + ';flex-shrink:0;font-weight:600">' + lbl + '</div>' +
        '<div style="flex:1;background:#1e1e1e;border-radius:6px;height:28px;overflow:hidden;position:relative">' +
          '<div style="width:' + w + '%;height:100%;background:' + fillColor + ';border-radius:6px;min-width:2px"></div>' +
          '<span style="position:absolute;right:8px;top:50%;transform:translateY(-50%);font-size:11px;font-weight:700;color:' + textColor + ';white-space:nowrap">' + val + (suffix || ' pts') + '</span>' +
        '</div>' +
      '</div>';
    };

    // Duelo de categorías: Tú vs El Promedio (fantasma)
    const dueloCats = [
      { label: 'PUNTOS',    you: myPts,       ghost: ghostPts,    unit: '', dec: 0 },
      { label: 'PRECISIÓN', you: accuracyPct, ghost: ghostAccPct, unit: '%', dec: 0 },
      { label: 'RACHA',     you: myStreak,    ghost: ghostStreak, unit: '', dec: 1 }
    ];
    let wins = 0, losses = 0, ties = 0;
    const duelRows = dueloCats.map(c => {
      const diff = c.you - c.ghost;
      let icon, color;
      if (Math.abs(diff) < 0.05) { icon = '➖'; color = '#888'; ties++; }
      else if (diff > 0)          { icon = '✅'; color = '#22c55e'; wins++; }
      else                        { icon = '❌'; color = '#ef4444'; losses++; }
      return '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;padding:9px 0;' +
        'border-bottom:1px solid rgba(255,255,255,0.06)">' +
        '<span style="font-size:10.5px;letter-spacing:1.5px;color:#777;font-weight:700;flex:1">' + c.label + '</span>' +
        '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:17px;color:#fff;min-width:44px;text-align:right">' + c.you.toFixed(c.dec) + c.unit + '</span>' +
        '<span style="font-size:16px">' + icon + '</span>' +
        '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:17px;color:#666;min-width:44px">' + c.ghost.toFixed(c.dec) + c.unit + '</span>' +
        '</div>';
    }).join('');

    const verdict = wins > losses
      ? { txt: '🏆 LE GANAS AL FANTASMA (' + wins + '-' + losses + (ties ? '-' + ties : '') + ')', color: '#22c55e' }
      : wins < losses
      ? { txt: '👻 EL FANTASMA TE GANA (' + losses + '-' + wins + (ties ? '-' + ties : '') + ')', color: '#ef4444' }
      : { txt: '⚖️ EMPATE TÉCNICO CONTRA EL FANTASMA', color: '#D4A017' };

    return '<div class="sr-q-h2h-grid" style="display:grid;grid-template-columns:1fr 1fr;gap:22px;align-items:start">' +
      '<div style="min-width:0">' +
        '<div style="font-size:9px;letter-spacing:2px;color:#444;margin-bottom:10px;text-transform:uppercase">Puntos — tú, líder y el fantasma</div>' +
        bar('🥇 Líder',  topPts,   'rgba(212,160,23,0.18)', '#888', '#888') +
        bar('👤 Tú',      myPts,   '#D4A017',               '#000', '#fff') +
        bar('👻 Fantasma',ghostPts,'rgba(140,140,150,0.35)', '#ddd', '#999') +
        '<div style="margin-top:8px">' +
          '<div style="background:#1a1a1a;border-radius:8px;height:8px;overflow:hidden">' +
            '<div style="width:' + pctile + '%;height:100%;background:linear-gradient(90deg,#333,' + pctColor + ');border-radius:8px"></div>' +
          '</div>' +
          '<div style="display:flex;justify-content:space-between;align-items:baseline;margin-top:6px">' +
            '<span style="font-size:9px;color:#333;letter-spacing:1px">PERCENTIL</span>' +
            '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:20px;color:' + pctColor + '">' + pctile + 'th</span>' +
            '<span style="font-size:10px;color:' + pctColor + '">' + pctLabel + '</span>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div style="min-width:0">' +
        '<div style="font-size:9px;letter-spacing:2px;color:#444;margin-bottom:2px;text-transform:uppercase">Duelo por categoría</div>' +
        duelRows +
        '<div style="margin-top:14px;text-align:center;padding:10px;border-radius:10px;background:rgba(255,255,255,0.03);' +
          'border:1px solid rgba(255,255,255,0.08);font-size:12px;font-weight:700;color:' + verdict.color + '">' + verdict.txt + '</div>' +
      '</div>' +
    '</div>';
  },

  _resolveStadium(partido) {
    const byId = {
      M29: 'AT&T Stadium, Arlington/Dallas',
      M30: 'Mercedes-Benz Stadium, Atlanta',
      M31: 'Hard Rock Stadium, Miami Gardens, Florida',
      M32: 'MetLife Stadium, East Rutherford, New Jersey'
    };
    if (byId[partido.id]) return byId[partido.id];

    const names = ((partido.local?.nombre || '') + ' ' + (partido.visitante?.nombre || '')).toLowerCase();
    const map = [
      { keys: ['canad','marruecos','morocco'],           sede: 'NRG Stadium, Houston' },
      { keys: ['paragua','franc'],                        sede: 'Lincoln Financial Field, Philadelphia' },
      { keys: ['brasil','brazil','noruega','norway'],     sede: 'MetLife Stadium, East Rutherford' },
      { keys: ['méx','mexico','inglat','england'],        sede: 'Estadio Azteca, Ciudad de México' },
      { keys: ['portug','croac','espa','spain'],          sede: 'AT&T Stadium, Arlington/Dallas' },
      { keys: ['estados','eeuu','usa','bélg','belg'],     sede: 'Lumen Field, Seattle' },
      { keys: ['argentin','cabo','austral','egipt'],      sede: 'Mercedes-Benz Stadium, Atlanta' },
      { keys: ['suiza','argel','colombia','ghana'],       sede: 'BC Place, Vancouver' },
    ];
    for (const s of map) { if (s.keys.some(k => names.includes(k))) return s.sede; }
    return partido.sede || '';
  },

  // ── SCORES ──────────────────────────────────────────────

  changeScore(matchId, side, delta) {
    if (!this.tempScores[matchId]) {
      const pred = this.getPrediction(matchId);
      this.tempScores[matchId] = {
        local:  pred ? pred.localScore : 0,
        away:   pred ? pred.awayScore  : 0,
        scorer: pred ? pred.scorer     : null
      };
    }
    const key = side === 'local' ? 'local' : 'away';
    this.tempScores[matchId][key] = Math.max(0, Math.min(9, this.tempScores[matchId][key] + delta));
    const elId = (side === 'local' ? 'sl-' : 'sa-') + matchId;
    const el = document.getElementById(elId);
    if (el) el.textContent = this.tempScores[matchId][key];
  },

  selectScorer(matchId, playerName, el) {
    const card = document.getElementById('card-' + matchId);
    if (card) card.querySelectorAll('.sr-q-scorer-option').forEach(o => o.classList.remove('selected'));
    el.classList.add('selected');
    if (!this.tempScores[matchId]) {
      const pred = this.getPrediction(matchId);
      this.tempScores[matchId] = {
        local: pred ? pred.localScore : 0,
        away:  pred ? pred.awayScore  : 0
      };
    }
    this.tempScores[matchId].scorer = playerName;
  },

  async savePrediction(matchId) {
    if (!this.currentUser) return this.toast('Debes iniciar sesión', 'error');

    // No basta con ocultar el formulario en la tarjeta: si el usuario la dejó
    // abierta desde antes de que cerrara, el botón "Guardar" seguía activo.
    // Se revalida aquí el mismo criterio de cierre que usa buildMatchCard
    // (finalizado / bloqueado / hora de cierre vencida) antes de escribir en
    // Firestore — no solo la hora, para cubrir también el caso en que el
    // admin ya cargó el resultado mientras la tarjeta seguía abierta.
    const partidoActual = ((this.data.matches && this.data.matches[this.currentPhase]) || [])
      .find(m => m.id === matchId);
    if (partidoActual) {
      const yaFinalizado = partidoActual.estado === 'finalizado';
      const yaBloqueado = partidoActual.estado === 'bloqueado';
      const yaVencido = partidoActual.lockAt && new Date() > new Date(partidoActual.lockAt);
      if (yaFinalizado || yaBloqueado || yaVencido) {
        this.renderMatches();
        return this.toast('🔒 El tiempo para predecir este partido ya cerró.', 'error');
      }
    }

    const prev = this.getPrediction(matchId);
    const tmp = this.tempScores[matchId] || {};

    const localScore = tmp.local !== undefined ? tmp.local : (prev ? prev.localScore : 0);
    const awayScore  = tmp.away  !== undefined ? tmp.away  : (prev ? prev.awayScore  : 0);
    const scorer = tmp.scorer !== undefined ? tmp.scorer : (prev ? prev.scorer : null);

    const predData = {
      localScore, awayScore, scorer,
      fase: this.currentPhase,
      savedAt: new Date().toISOString()
    };

    try {
      // set({...}, {merge:true}) con la clave del partido escribe SOLO ese campo
      // del documento — no toca las demás predicciones del usuario.
      await this.db.collection('predictions').doc(this.currentUser.uid)
        .set({ [matchId]: predData }, { merge: true });
    } catch (e) {
      if (this.isSessionError(e)) return this.handleSessionExpired();
      return this.toast('Error al guardar. Verifica tu conexión.', 'error');
    }

    if (!this.myPredictions) this.myPredictions = {};
    this.myPredictions[matchId] = predData;

    const card = document.getElementById('card-' + matchId);
    if (card) card.classList.add('saved');
    this.toast('✅ Predicción guardada: ' + localScore + '–' + awayScore + (scorer ? ' · ' + scorer : ''), 'success');
    this.launchConfetti();
    this.playSaveSound();

    // Update dashboard stats
    const stats = this.calculatePointsFor(this.myPredictions);
    const setTxt = (id, v) => { const el = document.getElementById(id); if (el) el.textContent = v; };
    setTxt('sr-q-user-pts', stats.puntos);
    setTxt('sr-q-user-hits', stats.aciertos + '/' + Object.keys(this.data.results).length);
  },

  getPrediction(matchId) {
    return (this.myPredictions || {})[matchId] || null;
  },

  // ── PUNTOS ──────────────────────────────────────────────

  calcMatchPoints(pred, result, fase) {
    if (!pred || !result) return 0;
    const pts = fase ? fase.puntos : { resultado: 2, exacto: 5, anotador: 2 };
    // Use Number() coercion so string-typed scores (legacy Firestore data) compare correctly
    const pL = Number(pred.localScore), pA = Number(pred.awayScore);
    const rL = Number(result.local),    rA = Number(result.visitante);
    const predRes = pL > pA ? 'H' : pL < pA ? 'A' : 'D';
    const realRes = rL > rA ? 'H' : rL < rA ? 'A' : 'D';
    if (predRes !== realRes) return 0;
    let total = pts.resultado;
    if (pL === rL && pA === rA) total += pts.exacto;
    const resultScorers = result.scorers || (result.scorer ? [result.scorer] : []);
    if (pred.scorer && resultScorers.length > 0 && resultScorers.includes(pred.scorer)) total += pts.anotador;
    return total;
  },

  calculatePointsFor(predictions) {
    predictions = predictions || {};
    const results = this.data.results || {};
    let totalPts = 0, streak = 0, aciertos = 0;

    // Orden cronológico real: por fase (en orden del torneo) y luego por número de partido.
    const matchFaseMap = {};
    const orderedMatchIds = [];
    MUNDIAL_DATA.fases.forEach(fase => {
      const partidos = ((this.data.matches && this.data.matches[fase.id]) || []).slice().sort((a, b) => a.num - b.num);
      partidos.forEach(p => { matchFaseMap[p.id] = fase; orderedMatchIds.push(p.id); });
    });

    orderedMatchIds.forEach(matchId => {
      const result = results[matchId];
      if (!result) return;
      const pred = predictions[matchId];
      if (!pred) { streak = 0; return; } // sin predicción en partido finalizado = racha rota
      const fase = matchFaseMap[matchId] || MUNDIAL_DATA.fases[0];
      const pts = this.calcMatchPoints(pred, result, fase);
      if (pts > 0) {
        totalPts += pts;
        aciertos++;
        streak++;
        if (streak === 3) totalPts += RACHA_BONUS.streak3;
        if (streak === 5) totalPts += RACHA_BONUS.streak5;
        if (streak === 8) totalPts += RACHA_BONUS.streak8;
      } else {
        streak = 0;
      }
    });
    return { puntos: totalPts, aciertos, total: Object.keys(results).length, streak };
  },

  // ── RANKING ─────────────────────────────────────────────

  async getAllUsersWithStats() {
    try {
      const [usersSnap, predsSnap] = await withTimeout(Promise.all([
        this.db.collection('users').get(),
        this.db.collection('predictions').get()
      ]), 8000);
      const predsByUid = {};
      predsSnap.forEach(doc => { predsByUid[doc.id] = doc.data(); });

      const users = [];
      usersSnap.forEach(doc => users.push({ uid: doc.id, ...doc.data() }));

      return users.map(user => {
        const preds = predsByUid[user.uid] || {};
        const stats = this.calculatePointsFor(preds);
        const predsCount = Object.keys(preds).length;
        return { ...user, ...stats, predsCount };
      }).sort((a, b) => b.puntos - a.puntos || b.predsCount - a.predsCount);
    } catch (e) {
      if (this.isSessionError(e)) { this.handleSessionExpired(); return []; }
      this.toast('No se pudo cargar el ranking. Verifica tu conexión.', 'error');
      return [];
    }
  },

  async renderRanking() {
    const tbody = document.getElementById('sr-q-ranking-body');
    if (!tbody) return;
    tbody.innerHTML = '<tr><td colspan="5" class="sr-q-empty">Cargando ranking…</td></tr>';

    const ranking = await this.getAllUsersWithStats();
    tbody.innerHTML = '';

    const countEl = document.getElementById('sr-q-ranking-count');
    const podiumEl = document.getElementById('sr-q-podium');

    if (ranking.length === 0) {
      tbody.innerHTML = '<tr><td colspan="5" class="sr-q-empty">Sé el primero en registrarte 🏆</td></tr>';
      if (countEl) countEl.textContent = '';
      if (podiumEl) podiumEl.innerHTML = '';
      this.renderSponsorStrip();
      return;
    }

    if (countEl) countEl.textContent = ranking.length + ' participante' + (ranking.length === 1 ? '' : 's');
    this.renderPodium(ranking);

    ranking.forEach((user, i) => {
      const pos = i + 1;
      const isCurrent = this.currentUser?.uid === user.uid;
      const medal = pos === 1 ? '🥇' : pos === 2 ? '🥈' : pos === 3 ? '🥉' : null;
      const pct = user.total > 0 ? Math.round((user.aciertos / user.total) * 100) : 0;
      const tr = document.createElement('tr');
      tr.className = isCurrent ? 'current-user' : '';
      tr.dataset.pos = pos;
      tr.style.animationDelay = (Math.min(i, 20) * 0.03) + 's';
      tr.innerHTML =
        '<td style="text-align:center">' +
          (medal ? '<span>' + medal + '</span>' : '<span class="sr-q-rank-pos">' + pos + '</span>') +
        '</td>' +
        '<td>' +
          '<div class="sr-q-rank-user">' +
            '<div class="sr-q-rank-avatar" style="background:' + this.avatarColor(user.username) + '">' + escapeHTML(user.avatar || user.nombre[0]) + '</div>' +
            '<div>' +
              '<div class="sr-q-rank-name">' + escapeHTML(user.nombre) + (isCurrent ? ' 👈' : '') + '</div>' +
              '<div class="sr-q-rank-sub">' + escapeHTML(user.seleccion || user.pais || '') + '</div>' +
            '</div>' +
          '</div>' +
        '</td>' +
        '<td>' +
          '<span class="sr-q-pts-badge' + (pos <= 3 ? ' sr-q-pts-badge--top' : '') + '">' + user.puntos + '</span>' +
          (user.streak >= 3 ? '<span class="sr-q-rank-streak" title="Racha de ' + user.streak + ' aciertos seguidos">🔥' + user.streak + '</span>' : '') +
        '</td>' +
        '<td>' +
          '<div class="sr-q-rank-hits">' + user.aciertos + '/' + user.total + '</div>' +
          '<div class="sr-q-rank-bar"><div class="sr-q-rank-bar-fill" style="width:' + pct + '%"></div></div>' +
        '</td>' +
        '<td>' + user.predsCount + '</td>';
      tbody.appendChild(tr);
    });

    this.applyRankingFilters();
    this.renderSponsorStrip();
  },

  // ── PODIO TOP 3 ─────────────────────────────────────────
  renderPodium(ranking) {
    const podiumEl = document.getElementById('sr-q-podium');
    if (!podiumEl) return;
    const [first, second, third] = ranking;
    podiumEl.innerHTML =
      this.buildPodiumCard(second, 2) +
      this.buildPodiumCard(first, 1) +
      this.buildPodiumCard(third, 3);
  },

  buildPodiumCard(user, pos) {
    if (!user) return '';
    const medal = pos === 1 ? '🥇' : pos === 2 ? '🥈' : '🥉';
    const isCurrent = this.currentUser?.uid === user.uid;
    return '<div class="sr-q-podium-card sr-q-podium-' + pos + (isCurrent ? ' current-user' : '') + '">' +
        (pos === 1 ? '<div class="sr-q-podium-crown">👑</div>' : '') +
        '<div class="sr-q-podium-medal">' + medal + '</div>' +
        '<div class="sr-q-rank-avatar sr-q-podium-avatar" style="background:' + this.avatarColor(user.username) + '">' +
          escapeHTML(user.avatar || user.nombre[0]) +
        '</div>' +
        '<div class="sr-q-podium-name">' + escapeHTML(user.nombre) + (isCurrent ? ' 👈' : '') + '</div>' +
        '<div class="sr-q-podium-sub">' + escapeHTML(user.seleccion || user.pais || '') + '</div>' +
        '<div class="sr-q-podium-pts">' + user.puntos + ' pts</div>' +
      '</div>';
  },

  // ── FILTROS / BÚSQUEDA DEL RANKING ───────────────────────
  rankingFilter: 'todos',
  rankingSearchQuery: '',

  setRankingFilter(filter, btnEl) {
    if (filter === 'yo') {
      // If top10 filter is active the user's row might be hidden — switch to todos first
      if (this.rankingFilter !== 'todos') {
        this.rankingFilter = 'todos';
        document.querySelectorAll('.sr-q-rank-filter').forEach(b => b.classList.remove('active'));
        const todosBtn = document.querySelector('.sr-q-rank-filter[data-filter="todos"]');
        if (todosBtn) todosBtn.classList.add('active');
        this.applyRankingFilters();
      }
      const row = document.querySelector('#sr-q-ranking-body tr.current-user');
      if (row) {
        setTimeout(() => {
          row.scrollIntoView({ behavior: 'smooth', block: 'center' });
          row.classList.add('sr-q-rank-flash');
          setTimeout(() => row.classList.remove('sr-q-rank-flash'), 1500);
        }, 50);
      } else {
        this.toast('No se encontró tu fila en el ranking', 'info');
      }
      return;
    }
    this.rankingFilter = filter;
    document.querySelectorAll('.sr-q-rank-filter').forEach(b => b.classList.remove('active'));
    if (btnEl) btnEl.classList.add('active');
    this.applyRankingFilters();
  },

  filterRanking(q) {
    this.rankingSearchQuery = q;
    this.applyRankingFilters();
  },

  applyRankingFilters() {
    const q = (this.rankingSearchQuery || '').toLowerCase();
    document.querySelectorAll('#sr-q-ranking-body tr[data-pos]').forEach(tr => {
      const pos = parseInt(tr.dataset.pos || '0', 10);
      const matchesSearch = !q || tr.textContent.toLowerCase().includes(q);
      const matchesFilter = this.rankingFilter === 'top10' ? pos <= 10 : true;
      tr.style.display = (matchesSearch && matchesFilter) ? '' : 'none';
    });
  },

  avatarColor(username) {
    username = username || '?';
    const colors = ['#D4A017','#ef4444','#22c55e','#3b82f6','#a855f7','#ec4899','#f97316'];
    let hash = 0;
    for (let i = 0; i < username.length; i++) hash = username.charCodeAt(i) + ((hash << 5) - hash);
    return colors[Math.abs(hash) % colors.length];
  },

  // ── PREMIOS ─────────────────────────────────────────────

  // Un premio guardado antes de esta ronda es un string plano; se trata como
  // { texto: elString } sin sponsor — sin necesitar ninguna migración manual.
  _normalizePremio(raw, fallbackTexto) {
    if (raw === undefined || raw === null) return { texto: fallbackTexto, sponsorName: '', sponsorLogo: '', sponsorUrl: '' };
    if (typeof raw === 'string') return { texto: raw, sponsorName: '', sponsorLogo: '', sponsorUrl: '' };
    return Object.assign({ texto: fallbackTexto, sponsorName: '', sponsorLogo: '', sponsorUrl: '' }, raw);
  },

  renderPrizes() {
    const container = document.getElementById('sr-q-prizes-list');
    if (container) {
      const premios = this.data.adminConfig.premios || {};
      const defaults = {
        primero: 'Camisola oficial a elección, personalizada (Q350 de valor)',
        segundo: '50% descuento en cualquier camisola',
        tercero: '25% descuento en cualquier camisola',
        top10: 'Envío gratis en tu próximo pedido de Soccer Revolution',
        exacto: 'Cupón de 10% por cada marcador exacto que aciertes'
      };

      container.innerHTML = [
        { key: 'primero', medal: '🥇', titulo: '1ER LUGAR' },
        { key: 'segundo', medal: '🥈', titulo: '2DO LUGAR' },
        { key: 'tercero', medal: '🥉', titulo: '3ER LUGAR' },
        { key: 'top10',   medal: '🎖️', titulo: 'TOP 10' },
        { key: 'exacto',  medal: '⚽',  titulo: 'MARCADOR EXACTO' }
      ].map(p => {
        const info = this._normalizePremio(premios[p.key], defaults[p.key]);
        return '<div class="sr-q-prize-card">' +
          '<div class="sr-q-prize-medal">' + p.medal + '</div>' +
          '<div class="sr-q-prize-info"><h3>' + p.titulo + '</h3><p>' + escapeHTML(info.texto) + '</p>' +
          (info.sponsorName
            ? '<div class="sr-q-prize-sponsor">' +
                '<span class="sr-q-prize-sponsor-label">ENTREGADO POR</span>' +
                (info.sponsorUrl
                  ? '<a href="' + escapeHTML(info.sponsorUrl) + '" target="_blank" rel="noopener">'
                  : '<span>') +
                (info.sponsorLogo
                  ? '<img class="sr-q-prize-sponsor-logo" src="' + escapeHTML(info.sponsorLogo) + '" alt="' + escapeHTML(info.sponsorName) + '">'
                  : escapeHTML(info.sponsorName)) +
                (info.sponsorUrl ? '</a>' : '</span>') +
              '</div>'
            : '') +
          '</div>' +
        '</div>';
      }).join('');
    }
    this.renderSponsorTitle();
    this.renderSponsorStrip();
  },

  // ── PATROCINADORES ───────────────────────────────────────
  // Título: banner destacado, máxima visibilidad — solo existe en el Dashboard.
  // Banner rotativo: franja de logos visible en Dashboard/Ranking/Premios/Mis Stats.
  // Ambos se cargan una vez por navegación en loadConfig() (this.data.sponsors).

  renderSponsorTitle() {
    const el = document.getElementById('sr-q-sponsor-title');
    if (!el) return;
    const s = this.data.sponsors.title;
    if (!s) { el.style.display = 'none'; el.innerHTML = ''; return; }
    el.style.display = '';
    const inner =
      '<span class="sr-q-sponsor-title-label">PRESENTADO POR</span>' +
      (s.logo
        ? '<img class="sr-q-sponsor-title-logo" src="' + escapeHTML(s.logo) + '" alt="' + escapeHTML(s.name) + '">'
        : '<span class="sr-q-sponsor-title-name">' + escapeHTML(s.name) + '</span>');
    el.innerHTML = s.url
      ? '<a href="' + escapeHTML(s.url) + '" target="_blank" rel="noopener" onclick="QuinielaApp.sponsorClick(\'' + s.id + '\')">' + inner + '</a>'
      : inner;
  },

  renderSponsorStrip() {
    // Las 4 pantallas (Dashboard/Ranking/Premios/Mis Stats) coexisten en el DOM a
    // la vez (solo se ocultan con CSS) — usar un id compartido haría que
    // getElementById siempre devolviera el primero (el del Dashboard) sin
    // importar cuál pantalla está realmente visible. Por eso cada mount point
    // usa una clase, y se actualizan todos (los ocultos no cuestan nada visible).
    document.querySelectorAll('.sr-q-sponsor-strip-mount').forEach(el => this._renderSponsorStripInto(el));
  },

  _renderSponsorStripInto(el) {
    // El timer se guarda EN el propio elemento (no en `this`) — con varios
    // mount points a la vez (uno por pantalla), un solo timer compartido en
    // `this` haría que solo el último procesado quedara realmente animado.
    clearInterval(el._sponsorRotateTimer);
    const banners = this.data.sponsors.banners || [];
    if (banners.length === 0) { el.style.display = 'none'; el.innerHTML = ''; return; }
    el.style.display = '';

    const item = s => {
      const inner = s.logo
        ? '<img class="sr-q-sponsor-item-logo" src="' + escapeHTML(s.logo) + '" alt="' + escapeHTML(s.name) + '">'
        : '<span class="sr-q-sponsor-item-name">' + escapeHTML(s.name) + '</span>';
      return '<div class="sr-q-sponsor-item">' +
        (s.url
          ? '<a href="' + escapeHTML(s.url) + '" target="_blank" rel="noopener" onclick="QuinielaApp.sponsorClick(\'' + s.id + '\')">' + inner + '</a>'
          : inner) +
      '</div>';
    };

    // Con pocos sponsors se muestran todos juntos, sin animación — la rotación
    // solo tiene sentido (y solo se activa) cuando no entran todos a la vez.
    if (banners.length <= 3) {
      el.innerHTML = '<div class="sr-q-sponsor-page active">' + banners.map(item).join('') + '</div>';
      return;
    }

    const pages = [];
    for (let i = 0; i < banners.length; i += 3) pages.push(banners.slice(i, i + 3));
    el.innerHTML = pages.map((page, i) =>
      '<div class="sr-q-sponsor-page' + (i === 0 ? ' active' : '') + '">' + page.map(item).join('') + '</div>'
    ).join('');

    let current = 0;
    el._sponsorRotateTimer = setInterval(() => {
      const pageEls = el.querySelectorAll('.sr-q-sponsor-page');
      if (pageEls.length < 2) return;
      pageEls[current].classList.remove('active');
      current = (current + 1) % pageEls.length;
      pageEls[current].classList.add('active');
    }, 4000);
    el.addEventListener('mouseenter', () => clearInterval(el._sponsorRotateTimer), { once: true });
  },

  // Registra un clic real en un sponsor (Título o Banner) para que el admin
  // tenga un dato de exposición real al negociar con marcas. No se trackean
  // impresiones (escribir en cada carga de pantalla saldría caro con 100+
  // usuarios activos) — solo clics reales, un solo incremento por clic.
  sponsorClick(id) {
    if (!id) return;
    this.db.collection('quiniela_sponsors').doc(id).update({
      clicks: firebase.firestore.FieldValue.increment(1)
    }).catch(() => {});
  },

  // ── TABLA DE PUNTOS (dinámica) ───────────────────────────
  // Antes era HTML estático hardcodeado en el .liquid (dos copias: landing +
  // modal "Cómo funciona"), desincronizado de MUNDIAL_DATA.fases en cuanto el
  // admin personalizara los puntos. Ahora ambas copias se generan desde el
  // mismo dato ya mutado por _applyPointsConfig().
  renderPointsTable() {
    const rowsHtml = MUNDIAL_DATA.fases.map(fase =>
      '<tr><td>' + fase.icono + ' ' + escapeHTML(fase.nombre.charAt(0) + fase.nombre.slice(1).toLowerCase()) + '</td>' +
        '<td>' + fase.puntos.resultado + ' pts</td>' +
        '<td>' + fase.puntos.exacto + ' pts</td>' +
        '<td>' + fase.puntos.anotador + ' pts</td></tr>'
    ).join('');
    const bonusHtml = '<strong>🔥 BONUS RACHA:</strong> 3 aciertos seguidos +' + RACHA_BONUS.streak3 +
      ' pts · 5 aciertos +' + RACHA_BONUS.streak5 + ' pts · 8 aciertos +' + RACHA_BONUS.streak8 + ' pts';

    ['sr-q-pts-table-landing-body', 'sr-q-pts-table-modal-body'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.innerHTML = rowsHtml;
    });
    const landingBonus = document.getElementById('sr-q-bonus-info-landing');
    if (landingBonus) landingBonus.innerHTML = bonusHtml;
    const modalBonus = document.getElementById('sr-q-bonus-info-modal');
    if (modalBonus) modalBonus.innerHTML = bonusHtml +
      '. La racha se rompe si fallas un partido o si no enviaste tu predicción a tiempo.';
  },

  // ── COUNTDOWN ───────────────────────────────────────────
  // Usa la hora LOCAL del dispositivo de cada visitante (sin forzar una
  // zona horaria fija) — comportamiento intencional, confirmado.

  startLandingCountdown() {
    const { fasesActivas = ['dieciseisavos'], lastActiveIdx = 0, matchesData = {} } = this.landingData || {};
    const faseShorts = {
      dieciseisavos: '16VOS', octavos: '8VOS', cuartos: 'CUARTOS',
      semifinal: 'SEMIS', tercer_lugar: '3ER', final: 'FINAL'
    };

    // ── Render phase progress pills ──
    const phasesEl = document.getElementById('sr-q-landing-phases');
    if (phasesEl) {
      phasesEl.innerHTML = '';
      MUNDIAL_DATA.fases.forEach((fase, idx) => {
        const pill = document.createElement('div');
        pill.className = 'sr-q-landing-phase-pill';
        const activated = fasesActivas.includes(fase.id);
        if (activated && idx < lastActiveIdx) {
          pill.classList.add('sr-q-lp-done');
          pill.textContent = '✓ ' + faseShorts[fase.id];
        } else if (activated && idx === lastActiveIdx) {
          pill.classList.add('sr-q-lp-active');
          pill.textContent = '🔥 ' + faseShorts[fase.id];
        } else if (idx === lastActiveIdx + 1) {
          pill.classList.add('sr-q-lp-next');
          pill.textContent = fase.icono + ' ' + faseShorts[fase.id];
        } else {
          pill.classList.add('sr-q-lp-future');
          pill.textContent = '○ ' + faseShorts[fase.id];
        }
        phasesEl.appendChild(pill);
      });
    }

    // ── Next phase countdown ──
    const nextIdx = lastActiveIdx + 1;
    const labelEl = document.getElementById('sr-q-landing-next-label');
    const titleEl = document.getElementById('sr-q-landing-next-title');
    const wrapEl  = document.getElementById('sr-q-landing-countdown-wrap');

    if (nextIdx >= MUNDIAL_DATA.fases.length) {
      if (labelEl) labelEl.textContent = 'ESTADO ACTUAL';
      if (titleEl) titleEl.textContent = '🏆 ¡GRAN FINAL EN CURSO!';
      const cdEl = wrapEl && wrapEl.querySelector('.sr-q-countdown');
      if (cdEl) cdEl.style.display = 'none';
      return;
    }

    const nextFase = MUNDIAL_DATA.fases[nextIdx];
    if (titleEl) titleEl.textContent = nextFase.icono + ' ' + nextFase.nombre;

    // Find earliest lockAt in next phase
    const nextMatches = matchesData[nextFase.id] || [];
    let firstLockAt = null;
    nextMatches.forEach(m => {
      if (m.lockAt) {
        const d = new Date(m.lockAt);
        if (!firstLockAt || d < firstLockAt) firstLockAt = d;
      }
    });

    if (!firstLockAt || firstLockAt <= new Date()) {
      if (labelEl) labelEl.textContent = 'PRÓXIMA FASE';
      const cdEl = wrapEl && wrapEl.querySelector('.sr-q-countdown');
      if (cdEl) cdEl.style.display = 'none';
      return;
    }

    const fmt = n => String(n).padStart(2, '0');
    const cdIds = ['sr-q-cd-days','sr-q-cd-hours','sr-q-cd-mins','sr-q-cd-secs'];
    const tick = () => {
      const diff = firstLockAt - new Date();
      if (diff <= 0) {
        cdIds.forEach(id => { const el = document.getElementById(id); if (el) el.textContent = '00'; });
        return;
      }
      const vals = [
        Math.floor(diff / 86400000),
        Math.floor((diff % 86400000) / 3600000),
        Math.floor((diff % 3600000) / 60000),
        Math.floor((diff % 60000) / 1000)
      ];
      cdIds.forEach((id, i) => { const el = document.getElementById(id); if (el) el.textContent = fmt(vals[i]); });
    };
    tick();
    setInterval(tick, 1000);
  },

  // ── CIERRE DE PREDICCIONES POR PARTIDO ───────────────────
  // partido.lockAt se guarda como ISO 8601 con 'Z' (instante UTC absoluto —
  // ver saveLockTime en sr-quiniela-admin.js: new Date(valorLocalDelAdmin)
  // .toISOString()). Por eso "new Date(lockAt) - new Date()" da el mismo
  // conteo real para CUALQUIER participante sin importar su zona horaria:
  // el admin ingresa la hora en hora de Guatemala desde su navegador, y
  // queda guardada como el instante absoluto correspondiente.

  startLockCountdowns() {
    const tick = () => this.tickLockCountdowns();
    tick();
    setInterval(tick, 1000);
  },

  tickLockCountdowns() {
    document.querySelectorAll('.sr-q-lock-countdown[data-lock-at]').forEach(el => {
      const target = new Date(el.dataset.lockAt);
      const diff = target - new Date();
      const textEl = el.querySelector('.sr-q-lock-countdown__text');

      if (diff <= 0) {
        // Ya cerró mientras la tarjeta estaba abierta — se refresca la lista
        // una sola vez para que el formulario se bloquee de verdad (no solo
        // visualmente), en vez de dejar el botón "Guardar" todavía activo.
        if (!el.dataset.expiredHandled) {
          el.dataset.expiredHandled = '1';
          this.renderMatches();
        }
        return;
      }

      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      const pad = n => String(n).padStart(2, '0');

      let label = d > 0
        ? d + 'd ' + pad(h) + 'h ' + pad(m) + 'm'
        : (h > 0 ? pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's' : pad(m) + 'm ' + pad(s) + 's');

      el.classList.toggle('sr-q-lock-countdown--urgent', diff < 3600000); // <1 hora
      if (textEl) textEl.textContent = 'Cierra en ' + label;
    });
  },

  // ── TOAST ───────────────────────────────────────────────

  toast(msg, type) {
    type = type || 'info';
    let el = document.getElementById('sr-q-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'sr-q-toast';
      el.className = 'sr-q-toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.className = 'sr-q-toast sr-q-toast-' + type + ' show';
    clearTimeout(el._timer);
    el._timer = setTimeout(() => el.classList.remove('show'), 3500);
  },

  // ── MODAL: CÓMO FUNCIONA / TÉRMINOS ──────────────────────

  showHowItWorksModal() {
    const overlay = document.getElementById('sr-q-how-modal-overlay');
    if (overlay) { overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  },
  closeHowItWorksModal() {
    const overlay = document.getElementById('sr-q-how-modal-overlay');
    if (overlay) { overlay.classList.remove('open'); document.body.style.overflow = ''; }
  },

  // ── EVENTS ──────────────────────────────────────────────

  init_events() {
    const regForm = document.getElementById('sr-q-register-form');
    if (regForm) regForm.addEventListener('submit', e => this.register(e));

    const loginForm = document.getElementById('sr-q-login-form');
    if (loginForm) loginForm.addEventListener('submit', e => this.login(e));

    const search = document.getElementById('sr-q-ranking-search');
    if (search) search.addEventListener('input', e => this.filterRanking(e.target.value));

    const howModalOverlay = document.getElementById('sr-q-how-modal-overlay');
    if (howModalOverlay) {
      howModalOverlay.addEventListener('click', e => {
        if (e.target === howModalOverlay) this.closeHowItWorksModal();
      });
    }
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') this.closeHowItWorksModal();
    });

    // Accesibilidad: permite activar con Enter/Espacio cualquier elemento con
    // role="button" que no sea ya un <button> nativo (ej. los <a onclick> de
    // navegación y las opciones de "Anotador Estrella" generadas dinámicamente).
    document.addEventListener('keydown', e => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const target = e.target;
      if (target && target.getAttribute && target.getAttribute('role') === 'button' && target.tagName !== 'BUTTON') {
        e.preventDefault();
        target.click();
      }
    });
  },

  // ── SONIDO ──────────────────────────────────────────────────

  soundEnabled: false,
  _audioCtx: null,

  initSound() {
    this.soundEnabled = localStorage.getItem('sr-q-sound') === '1';
    const btn = document.getElementById('sr-q-sound-btn');
    if (btn) {
      btn.textContent = this.soundEnabled ? '🔊' : '🔇';
      btn.classList.toggle('on', this.soundEnabled);
    }
  },

  toggleSound() {
    this.soundEnabled = !this.soundEnabled;
    localStorage.setItem('sr-q-sound', this.soundEnabled ? '1' : '0');
    const btn = document.getElementById('sr-q-sound-btn');
    if (btn) {
      btn.textContent = this.soundEnabled ? '🔊' : '🔇';
      btn.classList.toggle('on', this.soundEnabled);
    }
    this.toast(this.soundEnabled ? '🔊 Sonidos activados' : '🔇 Sonidos desactivados', 'info');
  },

  _getAudioCtx() {
    try {
      if (!this._audioCtx || this._audioCtx.state === 'closed') {
        this._audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      }
      return this._audioCtx;
    } catch(e) { return null; }
  },

  playSaveSound() {
    if (!this.soundEnabled) return;
    const ctx = this._getAudioCtx();
    if (!ctx) return;
    try {
      // Short ascending whistle: two tones
      [[880, 1320, 0, 0.18], [1320, 1760, 0.2, 0.38]].forEach(([f0, f1, t0, t1]) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain); gain.connect(ctx.destination);
        osc.type = 'sine';
        osc.frequency.setValueAtTime(f0, ctx.currentTime + t0);
        osc.frequency.exponentialRampToValueAtTime(f1, ctx.currentTime + t1);
        gain.gain.setValueAtTime(0.22, ctx.currentTime + t0);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t1 + 0.05);
        osc.start(ctx.currentTime + t0);
        osc.stop(ctx.currentTime + t1 + 0.07);
      });
    } catch(e) {}
  },

  playCelebrationSound() {
    if (!this.soundEnabled) return;
    const ctx = this._getAudioCtx();
    if (!ctx) return;
    try {
      // Ascending fanfare: C-E-G-C-E
      [523, 659, 784, 1047, 1319].forEach((freq, i) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain); gain.connect(ctx.destination);
        osc.type = i < 4 ? 'triangle' : 'sine';
        osc.frequency.value = freq;
        const t = ctx.currentTime + i * 0.12;
        gain.gain.setValueAtTime(0.18, t);
        gain.gain.exponentialRampToValueAtTime(0.001, t + 0.4);
        osc.start(t); osc.stop(t + 0.45);
      });
    } catch(e) {}
  },

  // ── CONFETTI ─────────────────────────────────────────────────

  launchConfetti(count) {
    count = count || 70;
    const colors = ['#D4A017','#f5c842','#22c55e','#ef4444','#3b82f6','#a855f7','#ffffff','#f97316'];
    const wrap = document.createElement('div');
    wrap.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:99996;overflow:hidden';
    document.body.appendChild(wrap);
    for (let i = 0; i < count; i++) {
      const p = document.createElement('div');
      const color = colors[i % colors.length];
      const size = 6 + Math.random() * 8;
      const left = 5 + Math.random() * 90;
      const delay = (Math.random() * 0.55).toFixed(2);
      const dur = (1.4 + Math.random() * 1.3).toFixed(2);
      const isRound = Math.random() > 0.45;
      p.style.cssText =
        'position:absolute;top:-14px;left:' + left + '%;' +
        'width:' + size + 'px;height:' + (isRound ? size : (size * 0.4).toFixed(1)) + 'px;' +
        'background:' + color + ';border-radius:' + (isRound ? '50%' : '2px') + ';' +
        'animation:sr-q-confetti-fall ' + dur + 's ' + delay + 's ease-in forwards';
      wrap.appendChild(p);
    }
    setTimeout(() => { if (wrap.parentNode) wrap.remove(); }, 3500);
  },

  // ── FLOATING POINTS ──────────────────────────────────────────

  showFloatingPoints(pts, emoji) {
    if (!pts || pts <= 0) return;
    const el = document.createElement('div');
    el.className = 'sr-q-float-pts';
    el.textContent = '+' + pts + ' pts ' + (emoji || '⚽');
    document.body.appendChild(el);
    setTimeout(() => { if (el.parentNode) el.remove(); }, 1900);
  },

  // ── RANKING CELEBRACIÓN ──────────────────────────────────────

  checkRankingImprovement(newPos) {
    if (!newPos || newPos < 1 || !this.currentUser) return;
    const key = 'sr-q-rank-' + this.currentUser.uid;
    const prev = parseInt(localStorage.getItem(key) || '0', 10);
    localStorage.setItem(key, String(newPos));
    if (prev > 0 && newPos < prev) {
      setTimeout(() => this.showRankingCelebration(prev, newPos), 700);
    }
  },

  showRankingCelebration(fromPos, toPos) {
    if (document.querySelector('.sr-q-rank-celebrate')) return;
    const sub = toPos === 1 ? '👑 ¡Eres el líder!' : toPos <= 3 ? '🏅 ¡Estás en el podio!' : '¡Sigue así, vas subiendo!';
    const overlay = document.createElement('div');
    overlay.className = 'sr-q-rank-celebrate';
    overlay.innerHTML =
      '<div class="sr-q-rank-celebrate__card">' +
        '<span class="sr-q-rank-celebrate__icon">🚀</span>' +
        '<div class="sr-q-rank-celebrate__title">¡SUBISTE EN EL RANKING!</div>' +
        '<div class="sr-q-rank-celebrate__from">#' + fromPos + ' → <span>#' + toPos + '</span></div>' +
        '<div class="sr-q-rank-celebrate__sub">' + sub + '</div>' +
        '<button onclick="this.closest(\'.sr-q-rank-celebrate\').remove()" ' +
          'class="sr-q-btn sr-q-btn-primary" style="margin-top:24px;justify-content:center">¡Genial! 🎉</button>' +
      '</div>';
    overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove(); });
    document.body.appendChild(overlay);
    this.launchConfetti(90);
    this.playCelebrationSound();
    setTimeout(() => { if (overlay.parentNode) overlay.remove(); }, 9000);
  },

  // ── COMPARTIR ──────────────────────────────────────────────

  shareMatchPrediction(matchId) {
    const faseId = this.currentPhase;
    const fase = MUNDIAL_DATA.fases.find(f => f.id === faseId);
    const partidos = (this.data.matches && this.data.matches[faseId]) || [];
    const partido = partidos.find(p => p.id === matchId);
    const pred = this.getPrediction(matchId);
    if (!partido || !pred) return;

    const local = partido.local.nombre;
    const visit = partido.visitante.nombre;
    const score = pred.localScore + '–' + pred.awayScore;
    const scorer = pred.scorer ? ' (⚽ ' + pred.scorer + ')' : '';
    const phaseName = fase ? fase.nombre : '';
    const userName = this.currentUser ? this.currentUser.nombre : '';
    const pageUrl = window.location.href.split('?')[0];
    const shareText = '⚽ ' + userName + ' predice: ' + local + ' ' + score + ' ' + visit + scorer +
      '\n🏆 ' + phaseName + ' — Quiniela Soccer Revolution 2026' +
      '\n¡Únete en: ' + pageUrl;

    if (navigator.share) {
      navigator.share({ title: 'Mi predicción ⚽', text: shareText }).catch(() => {});
      return;
    }
    this._showSharePredModal(partido, pred, fase, shareText);
  },

  _showSharePredModal(partido, pred, fase, shareText) {
    const existing = document.getElementById('sr-q-share-pred-modal');
    if (existing) existing.remove();

    const local = partido.local;
    const visit = partido.visitante;
    const localIcon = local.bandera || local.nombre.charAt(0);
    const visitIcon = visit.bandera || visit.nombre.charAt(0);
    const phaseName = fase ? fase.icono + ' ' + fase.nombre : '';
    const userName = this.currentUser ? escapeHTML(this.currentUser.nombre) : '';
    const scorer = pred.scorer ? '<div class="sr-q-share-card__scorer">⚽ ' + escapeHTML(pred.scorer) + '</div>' : '';
    const waText = encodeURIComponent(shareText);

    const overlay = document.createElement('div');
    overlay.id = 'sr-q-share-pred-modal';
    overlay.className = 'sr-q-modal-overlay';
    overlay.innerHTML =
      '<div class="sr-q-modal" style="max-width:420px;padding:0;overflow:hidden">' +
        '<div class="sr-q-share-card">' +
          '<div class="sr-q-share-card__phase">' + phaseName + '</div>' +
          '<div class="sr-q-share-card__teams">' +
            '<div class="sr-q-share-card__team">' +
              '<span class="sr-q-share-card__flag">' + localIcon + '</span>' +
              '<span class="sr-q-share-card__name">' + escapeHTML(local.nombre) + '</span>' +
            '</div>' +
            '<div class="sr-q-share-card__score">' +
              pred.localScore + '<span>—</span>' + pred.awayScore +
            '</div>' +
            '<div class="sr-q-share-card__team">' +
              '<span class="sr-q-share-card__flag">' + visitIcon + '</span>' +
              '<span class="sr-q-share-card__name">' + escapeHTML(visit.nombre) + '</span>' +
            '</div>' +
          '</div>' +
          scorer +
          '<div class="sr-q-share-card__by">' + userName + ' · Soccer Revolution 2026</div>' +
        '</div>' +
        '<div class="sr-q-share-actions">' +
          '<a href="https://wa.me/?text=' + waText + '" target="_blank" rel="noopener" ' +
            'class="sr-q-btn sr-q-btn-primary" style="justify-content:center;text-decoration:none">💬 Compartir en WhatsApp</a>' +
          '<button class="sr-q-btn sr-q-btn-dark js-copy-share" style="justify-content:center">📋 Copiar texto</button>' +
          '<button class="sr-q-btn sr-q-btn-dark js-close-share" style="justify-content:center">Cerrar</button>' +
        '</div>' +
      '</div>';

    overlay.querySelector('.js-copy-share').addEventListener('click', function() {
      QuinielaApp.copyToClipboard(shareText, this, '📋 Copiar texto', '✅ Copiado');
    });
    overlay.querySelector('.js-close-share').addEventListener('click', () => overlay.remove());
    overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove(); });
    document.body.appendChild(overlay);
  },

  shareMyPosition() {
    const pos = document.getElementById('sr-q-user-pos')?.textContent || '—';
    const pts = document.getElementById('sr-q-user-pts')?.textContent || '0';
    const name = this.currentUser ? this.currentUser.nombre : '';
    const pageUrl = window.location.href.split('?')[0];
    const shareText = '🏆 ' + name + ' está en posición ' + pos + ' con ' + pts + ' pts ⚽' +
      '\n¡Únete a la Quiniela Soccer Revolution 2026: ' + pageUrl;

    if (navigator.share) {
      navigator.share({ title: 'Mi posición en la Quiniela', text: shareText }).catch(() => {});
      return;
    }
    window.open('https://wa.me/?text=' + encodeURIComponent(shareText), '_blank');
  },

  copyToClipboard(text, btn, labelDefault, labelSuccess) {
    navigator.clipboard.writeText(text).then(() => {
      this.toast('📋 ¡Copiado al portapapeles!', 'success');
      if (btn) {
        const orig = labelDefault || btn.textContent;
        btn.textContent = labelSuccess || '✅ Copiado';
        setTimeout(() => { btn.textContent = orig; }, 2200);
      }
    }).catch(() => this.toast('No se pudo copiar. Copia manualmente.', 'error'));
  },

  // ── GRUPOS PRIVADOS ──────────────────────────────────────────

  myGroup: null,

  _genGroupCode() {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    return Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  },

  async loadMyGroup() {
    if (!this.currentUser || !this.currentUser.grupoCode) { this.myGroup = null; return null; }
    try {
      const snap = await withTimeout(this.db.collection('grupos').doc(this.currentUser.grupoCode).get(), 5000);
      if (!snap.exists || !(snap.data().members || {})[this.currentUser.uid]) {
        this.myGroup = null;
        await this.db.collection('users').doc(this.currentUser.uid)
          .update({ grupoCode: firebase.firestore.FieldValue.delete() });
        this.currentUser.grupoCode = null;
        return null;
      }
      this.myGroup = { ...snap.data(), id: snap.id };
      return this.myGroup;
    } catch(e) { return null; }
  },

  async createGroup(name) {
    name = (name || '').trim().substring(0, 40);
    if (!name) return this.toast('Escribe un nombre para el grupo', 'error');
    if (!this.currentUser) return;
    if (this.currentUser.grupoCode) return this.toast('Ya estás en un grupo. Sal primero para crear uno nuevo.', 'error');

    let code, attempts = 0;
    do {
      code = this._genGroupCode();
      const snap = await withTimeout(this.db.collection('grupos').doc(code).get(), 4000);
      if (!snap.exists) break;
    } while (++attempts < 5);

    const groupData = {
      name, code,
      createdBy: this.currentUser.uid,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      members: { [this.currentUser.uid]: true }
    };
    try {
      await this.db.collection('grupos').doc(code).set(groupData);
      await this.db.collection('users').doc(this.currentUser.uid).set({ grupoCode: code }, { merge: true });
      this.currentUser.grupoCode = code;
      this.myGroup = { ...groupData, id: code };
      this.toast('✅ Grupo "' + escapeHTML(name) + '" creado. Código: ' + code, 'success');
      this.renderGrupoScreen();
    } catch(e) { this.toast('Error al crear: ' + e.message, 'error'); }
  },

  async joinGroup(code) {
    code = (code || '').trim().toUpperCase().substring(0, 6);
    if (!code) return this.toast('Escribe el código del grupo', 'error');
    if (!this.currentUser) return;
    if (this.currentUser.grupoCode) return this.toast('Ya estás en un grupo. Sal primero para unirte a otro.', 'error');

    try {
      const snap = await withTimeout(this.db.collection('grupos').doc(code).get(), 5000);
      if (!snap.exists) return this.toast('Código no encontrado. Verifica que sea correcto.', 'error');
      const data = snap.data();
      if (Object.keys(data.members || {}).length >= 50) return this.toast('Este grupo ya está lleno (máx. 50).', 'error');

      await this.db.collection('grupos').doc(code).set({ members: { [this.currentUser.uid]: true } }, { merge: true });
      await this.db.collection('users').doc(this.currentUser.uid).set({ grupoCode: code }, { merge: true });
      this.currentUser.grupoCode = code;
      this.myGroup = { ...data, id: code, members: { ...(data.members || {}), [this.currentUser.uid]: true } };
      this.toast('✅ ¡Te uniste al grupo "' + escapeHTML(data.name) + '"!', 'success');
      this.renderGrupoScreen();
    } catch(e) { this.toast('Error al unirse: ' + e.message, 'error'); }
  },

  async leaveGroup() {
    if (!this.currentUser?.grupoCode) return;
    if (!confirm('¿Salir del grupo "' + (this.myGroup?.name || '') + '"?')) return;
    const code = this.currentUser.grupoCode;
    try {
      await this.db.collection('grupos').doc(code)
        .update({ ['members.' + this.currentUser.uid]: firebase.firestore.FieldValue.delete() });
      await this.db.collection('users').doc(this.currentUser.uid)
        .update({ grupoCode: firebase.firestore.FieldValue.delete() });
      this.currentUser.grupoCode = null;
      this.myGroup = null;
      this.toast('Saliste del grupo.', 'info');
      this.renderGrupoScreen();
    } catch(e) { this.toast('Error: ' + e.message, 'error'); }
  },

  async renderGrupoScreen() {
    const container = document.getElementById('sr-q-grupo-content');
    if (!container) return;
    container.innerHTML = '<div class="sr-q-empty"><p>Cargando…</p></div>';

    await this.loadMyGroup();

    if (!this.myGroup) {
      container.innerHTML =
        '<div class="sr-q-grupo-empty">' +
          '<span class="sr-q-grupo-empty__icon">👥</span>' +
          '<h3>Aún no estás en ningún grupo</h3>' +
          '<p>Crea un grupo y comparte el código con tus amigos,<br>o únete con el código de alguien.</p>' +
          '<div class="sr-q-grupo-forms">' +
            '<div class="sr-q-grupo-form-section">' +
              '<h4>🆕 Crear grupo</h4>' +
              '<input type="text" id="sr-q-grupo-name" class="sr-q-form-input" placeholder="Nombre del grupo (ej: Los Cuates)" maxlength="40">' +
              '<button class="sr-q-btn sr-q-btn-primary" style="width:100%;justify-content:center;margin-top:10px" ' +
                'onclick="QuinielaApp.createGroup(document.getElementById(\'sr-q-grupo-name\').value)">✅ Crear grupo</button>' +
            '</div>' +
            '<div class="sr-q-grupo-form-divider">— o —</div>' +
            '<div class="sr-q-grupo-form-section">' +
              '<h4>🔑 Unirse con código</h4>' +
              '<input type="text" id="sr-q-grupo-code" class="sr-q-form-input" placeholder="Código (ej: ABC123)" ' +
                'maxlength="6" style="text-transform:uppercase;letter-spacing:4px;font-size:20px;text-align:center">' +
              '<button class="sr-q-btn sr-q-btn-dark" style="width:100%;justify-content:center;margin-top:10px" ' +
                'onclick="QuinielaApp.joinGroup(document.getElementById(\'sr-q-grupo-code\').value)">🔑 Unirse</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      return;
    }

    const code = this.myGroup.code || this.myGroup.id;
    const memberUids = Object.keys(this.myGroup.members || {});
    const allUsers = await this.getAllUsersWithStats();
    const groupUsers = allUsers.filter(u => memberUids.includes(u.uid));

    let rows = '';
    groupUsers.forEach((u, i) => {
      const isMe = u.uid === this.currentUser.uid;
      const medal = i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : (i + 1) + '.';
      rows +=
        '<tr class="' + (isMe ? 'sr-q-me-row' : '') + '">' +
          '<td style="font-size:18px;text-align:center">' + medal + '</td>' +
          '<td>' + escapeHTML(u.nombre) + (isMe ? ' <span style="color:#D4A017;font-size:11px">← tú</span>' : '') + '</td>' +
          '<td style="color:#D4A017;font-weight:700;text-align:center">' + u.puntos + '</td>' +
          '<td style="text-align:center">' + u.aciertos + '</td>' +
        '</tr>';
    });
    if (!rows) rows = '<tr><td colspan="4" style="text-align:center;color:#555;padding:20px">Nadie en el ranking aún.</td></tr>';

    container.innerHTML =
      '<div class="sr-q-grupo-header">' +
        '<div class="sr-q-grupo-name">👥 ' + escapeHTML(this.myGroup.name) + '</div>' +
        '<div class="sr-q-grupo-code-display">' +
          '<span>CÓDIGO DE INVITACIÓN</span>' +
          '<strong>' + escapeHTML(code) + '</strong>' +
          '<button class="sr-q-btn sr-q-btn-dark" style="padding:6px 14px;font-size:13px" ' +
            'onclick="QuinielaApp.shareGroupCode(\'' + escapeHTML(code) + '\',\'' + escapeHTML(this.myGroup.name).replace(/'/g, '\\\'') + '\')">📤 Compartir código</button>' +
        '</div>' +
        '<div class="sr-q-grupo-meta">' + memberUids.length + ' miembro' + (memberUids.length !== 1 ? 's' : '') + '</div>' +
      '</div>' +
      '<h4 class="sr-q-grupo-ranking-title">RANKING DEL GRUPO</h4>' +
      '<div class="sr-q-grupo-ranking-wrap">' +
        '<table class="sr-q-ranking-table">' +
          '<thead><tr><th>#</th><th>PARTICIPANTE</th><th>PUNTOS</th><th>ACIERTOS</th></tr></thead>' +
          '<tbody>' + rows + '</tbody>' +
        '</table>' +
      '</div>' +
      '<button class="sr-q-btn sr-q-btn-danger" onclick="QuinielaApp.leaveGroup()" style="width:100%;justify-content:center">🚪 Salir del grupo</button>';
  },

  shareGroupCode(code, name) {
    const pageUrl = window.location.href.split('?')[0];
    const text = '¡Únete a mi grupo "' + name + '" en la Quiniela Soccer Revolution 2026! 🏆\nCódigo: ' + code + '\n👉 ' + pageUrl;
    if (navigator.share) {
      navigator.share({ title: 'Únete a mi grupo', text }).catch(() => {});
      return;
    }
    window.open('https://wa.me/?text=' + encodeURIComponent(text), '_blank');
  }
};

// ── FALLBACK SI LA APP NO LOGRA CARGAR ──────────────────────
// Antes, si el SDK de Firebase no cargaba (red móvil lenta/inestable, CDN
// bloqueado, una sesión guardada cuya verificación se queda esperando sin
// responder, etc.), la app se quedaba en silencio con la pantalla negra
// vacía para siempre — solo se veía el menú del tema por encima. Ahora, si
// no se logra mostrar ninguna pantalla en un tiempo razonable, se muestra un
// mensaje claro con un botón para reintentar.
QuinielaApp.showFatalError = function() {
  const app = document.getElementById('sr-quiniela-app');
  if (!app) return;
  app.innerHTML =
    '<div style="min-height:60vh;display:flex;flex-direction:column;align-items:center;' +
    'justify-content:center;text-align:center;padding:40px 20px;gap:16px">' +
      '<span style="font-size:48px">⚠️</span>' +
      '<h2 style="font-family:\'Bebas Neue\',sans-serif;color:#D4A017;letter-spacing:2px;font-size:22px;margin:0">' +
        'NO SE PUDO CARGAR LA QUINIELA' +
      '</h2>' +
      '<p style="color:#888;font-size:14px;max-width:360px;margin:0">' +
        'Puede ser tu conexión a internet o un bloqueador de contenido. Verifica tu conexión e intenta de nuevo.' +
      '</p>' +
      '<button onclick="location.reload()" class="sr-q-btn sr-q-btn-primary" style="margin-top:8px">' +
        '🔄 REINTENTAR' +
      '</button>' +
    '</div>';
};

document.addEventListener('DOMContentLoaded', function() {
  // Vigilante: si en 8 segundos no se mostró ninguna pantalla, asumimos que
  // algo se colgó (sin importar la causa exacta) y mostramos el mensaje de
  // error en vez de dejar la pantalla negra vacía indefinidamente.
  const watchdog = setTimeout(function() {
    if (!document.querySelector('.sr-q-screen.active')) QuinielaApp.showFatalError();
  }, 8000);

  try {
    if (typeof firebase === 'undefined' || !firebase.firestore || !firebase.auth) {
      throw new Error('El SDK de Firebase no se cargó correctamente');
    }
    Promise.resolve(QuinielaApp.init()).catch(function() {
      clearTimeout(watchdog);
      QuinielaApp.showFatalError();
    });
  } catch (e) {
    clearTimeout(watchdog);
    QuinielaApp.showFatalError();
  }

  QuinielaApp.init_events();
});
